export default {
  scriptOps: {"title":"剧本局部优化","scope":"勾选场景以优化片段；不勾选则优化整集。结果保存为待复核版本。","operator":"优化方向","opening":"强化开头","conflict":"强化冲突","satisfaction":"强化爽点","reversal":"强化反转","hook":"强化钩子","cinematic":"强化镜头感","shorten":"精简","running":"正在优化","apply":"生成优化版本","saved":"已保存待复核版本","lengthDrift":"篇幅变化超过提示阈值，请复核。"},
  visualIdentity: {title: '视觉身份锚点', bone_structure: '骨相', facial_features: '五官', marks: '辨识标记', colors: '色彩', texture: '纹理', hair: '发型', clothing: '服装'},
  refOutdated: {empty: '当前没有建议重生成的图像。', invalid: '无法读取参考图更新详情。', title: '参考图已更新，建议重生成', legacy: '依赖推断', exact: '原参考图已变更'},

  contextWarnings: {unrecorded: "生成已继续，但上下文截断记录未能保存。",sources:{"screenplay_json":"剧本","rag":"检索资料","canon":"设定","chapter_history":"前文","chapter_text":"章节正文","storyboard":"分镜","screenplay":"剧本"},reasons:{"pretrim_budget_exceeded":"剧本超出上下文额度","source_budget_exceeded":"超出此类上下文额度","total_budget_exceeded":"上下文总额度不足","total_budget_truncated":"按剩余额度缩短","empty_content":"内容为空"},other:"其他原因","title":"本章上下文被截断的部分","truncated":"已截断","dropped":"已丢弃","failed":"上下文摘要读取失败，请重试"},
 mediaProvenance: {"title":"此成片含替代或简化内容","storyboard":"这是分镜版","other":"其他原因：{{reason}}","reasons":{"context_warnings_unrecorded":"生成已继续，但上下文截断记录未能保存。","degraded_clip_unavailable":"视频片段不可用，已使用分镜画面","degraded_panel_placeholder":"分镜图片不可用，已使用占位画面","degraded_no_subtitle":"未生成字幕","degraded_subtitle_error":"字幕生成失败","degraded_bgm_unavailable":"背景音乐不可用","degraded_audio_mix":"音频混合失败，已使用原始音轨","degraded_clip_stretch":"视频片段时长已调整"}},
 projectBudget: {submissionWarnings: "最近 {{count}} 次提交曾接近项目预算上限。",stages:{"text":"文字","image":"图像","panel":"分镜图","audio":"音频","video":"视频","other":"其他"},"title":"项目预算上限","unlimited":"不限","hint":"留空表示不限。提交时计入在途占用，并按保守预估上界检查，可能拦下实际费用较低的任务。","invalid":"请输入非负整数，或留空。","failed":"预算读取或保存失败","usage":"已花费 {{spent}} 积分 · 在途占用 {{active}} 积分","warning":"接近项目预算上限","exceeded":"已超过项目预算上限"},
  diegeticEditor: {
    title: '调整纸面文字', save: '保存修改', reset: '复位', cancel: '取消',
    help: '拖动载体框或四角调整位置与大小。保存本页已调整的框；复位将本页所有框恢复到原始位置。聚焦框后可用方向键移动，上档键 + 方向键调整大小。',
    fallback: '未识别位置的框暂放在所属分镜中央，请拖到纸面上再保存。',
    carrier: '载体 {{number}}', move: '移动载体 {{number}}',
    nw: '调整左上角', ne: '调整右上角', sw: '调整左下角', se: '调整右下角',
    saving: '正在保存位置…', composing: '位置已保存，正在重新合成并等待页面更新…',
    loadFailed: '文字位置加载失败，请重试后调整本页。',
    saveFailed: '部分或全部位置未能保存，已保留编辑内容，请重试保存或复位。',
    composeFailed: '位置已保存，但尚未确认页面更新。请重试保存或复位以重新合成。',
  },
  pagePreflight: { loading: '正在检查合页条件', failed: '合页条件检查失败，请刷新重试', storyboard: '分镜尚未通过复核', storyboard_panels: '分镜尚无单格', panelImage: '单格 {{id}} 尚未出图' },
  pagePreview: { title: '成品页', page: '第 {{page}} / {{total}} 页', fallback: '已回退到固定版式', degraded: '降级原因', imageFailed: '图片加载失败，请刷新页面重试。', refresh: '刷新', loading: '正在加载成品页…', loadFailed: '成品页加载失败，请重试。', empty: '尚未合成成品页', compose: '合成成品页', submitting: '正在提交…', queued: '合成任务已入队，完成后点击刷新查看。', composeFailed: '合成提交失败，请重试。' },
  creatorReview: { approve: '通过', reject: '驳回', reason: '评审理由（驳回必填）', saved: '评审已保存，请手动启动下一工位' },
  characterDesign: {
    discard: '丢弃候选',
    instructions: '先保存外观，再抽取候选；比较四个视图后选定并锁定。', appearance: '角色外观', save: '保存外观', suggest: 'AI 建议', draw: '抽卡', replay: '复现此候选', lock: '选定并锁定', locked: '已锁定', candidate: '候选', failed: '生成失败', seed: '种子', generating: '正在生成四视图', loading: '正在读取', missingAppearance: '{{name}}：外观未填', unsaved: '外观尚未保存，请先保存再抽卡。', noCharacters: '暂无已分类的角色，请先检查设定项分类。', noCandidates: '还没有候选，保存外观后可以开始抽卡。', imageUnavailable: '图像暂不可用', imageAlt: '{{name}} 四视图候选', classification: '设定项分类与纠正', classify: '补齐未分类项', kind: '分类', kinds: { character: '角色', prop: '道具', location: '地点', organization: '组织', unknown: '待确认' },
  },
  sceneLock: { title: '场景锁定', create: '新建', save: '保存锁定', saved: '场景锁定已保存', saveFailed: '场景锁定保存失败', id: '场景 ID', setting: '场景设定', weather: '天气', lighting: '光照', props: '道具', reason: '覆盖原因' },
  refinement: { candidate: "精修候选", referenceWarning: '精修改动了人称/指代，请在采纳前核对。', history: '版本历史', volumeTXT: '卷 TXT', exportVolumeTXT: '导出当前卷 TXT' },
  cascadeEstimate: { noData: '暂无数据', failed: '暂时无法获取预估' },
  foreshadowDebt: {pending: '待决定：{{count}} 条（确认前须全部处理）', suggestion: '建议改期到本卷末、标长线并指定后续章，或删除。', rescheduleAll: '全部改期到本卷末', noFutureVolumeEnd: '本卷末不是后续章或尚未设置，请逐条决定。',decisions: '请为这些伏笔安排兑现卷、标长线或删除', title: '本章必须兑现', limit: '本章新埋伏笔上限：{{count}} 条', empty: '本章没有到期伏笔。', target: '新的回收章节', reschedule: '改期', long: '标长线', delete: '删除伏笔', failed: '伏笔决定保存失败'},
  contentMode: {
    label: '创作模式',
    current: '当前: {{value}}',
    currentLabel: '当前',
    easy: '简易',
    advanced: '高级',
  },
  autopilot: {
    title: '自动写作',
    status: {
      planning: '准备中', running: '写作中', paused: '已停下', blocked_plan: '等待大纲',
      blocked_credits: '信用点不足', completed: '已完成', failed: '已失败', cancelled: '已结束',
    },
    progress: '第 {{current}}/{{end}} 章{{title}} · 已花 {{spent}}/{{estimated}} 点',
    lastQuality: '最近质量分：{{score}}',
    nextCheckpoint: '下一个停点：第 {{chapter}} 章',
    pause: '停下',
    resume: '继续写',
    editOutline: '改大纲后继续',
    cancel: '结束运行',
    checkpointTitle: '本次停点已生成的正文',
    chapterTitle: '第 {{chapter}} 章 · {{title}}',
    noProse: '还没有可展示的正文。',
    actionFailed: '自动写作操作失败。',
    reason: {
 budget: '项目预算不足：在途占用与保守预估已计入上限。',
      checkpoint: '已到达预定停点，请阅读正文后决定下一步。',
      credits: '信用点不足，补充后可继续。',
      quality: '连续多章质量评分未达标，需要你决定下一步。',
      needs_review: '本章产出需要你确认后才能继续。',
      job_failed: '本章生成失败，可重试或调整后继续。',
      user: '你已暂停自动写作。',
      invariant_violation: '运行条件已变化，请检查后继续。',
      andon: '安灯保护已触发，请检查当前正文。',
    },
  },
  app: { name: 'Novel-Factory', tagline: '给故事的工业车间' },
  languageNames: {
    zh: '中文',
    en: '英文',
    ja: '日语',
    ko: '韩语',
    fr: '法语',
    de: '德语',
    es: '西班牙语',
    it: '意大利语',
    ru: '俄语',
    pt: '葡萄牙语',
    ar: '阿拉伯语',
    th: '泰语',
    vi: '越南语',
    id: '印尼语',
  },
  nav: {
    home: '首页',
    projects: '项目',
    trash: '回收站',
    board: '脉动看板',
    library: '作品库',
    consistency: '一致性',
    skills: '技能',
    billing: '计量计费',
    gameplay: '玩法看板',
    admin: '管理',
  },
  login: {
    title: '登录 Novel-Factory',
    subtitle: '跨站独立域 · 安全会话',
    username: '用户名',
    password: '密码',
    captchaLabel: '验证码',
    captchaRefresh: '刷新',
    captchaPlaceholder: '请输入 6 位验证码',
    captchaInvalid: '验证码错误或已过期',
    submit: '登录',
    submitting: '登录中',
    required: '请输入用户名和密码',
    failed: '登录失败，请检查用户名或密码',
  },
  shell: {
    bootstrapFailed: '请稍后重试，或重新登录。',
    credits: '信用点',
    creditsUnlimited: '信用点未启用，不计费',
    creditsUnlimitedLabel: '无限',
    toggleTheme: '切换暗亮态',
    appVersion: '系统版本',
    command: '命令',
    commandShortcut: 'Ctrl K',
    userMenu: '用户菜单',
    currentUser: '当前用户',
    commandTitle: '命令面板',
    commandDescription: '快速跳转与执行常用动作',
    commandPlaceholder: '搜索命令或页面',
    commandEmpty: '没有匹配命令',
    commandNavigate: '导航',
    commandActions: '操作',
    lightMode: '亮态',
    darkMode: '暗态',
    menuBilling: '账单与用量',
    menuAccountSettings: '账户设置',
    menuAdmin: '管理后台',
    adminBadge: '管理员',
    healthNormal: '正常',
    healthAbnormal: '异常',
    healthUnchecked: '未检测',
    healthTooltip: '后台服务：{{status}}',
    healthCheckedAt: '最近检测：{{time}}',
    helpManual: '用户手册',
  },
  home: {
    eyebrow: '总览',
    title: '指挥中心',
    subtitle: '只保留今天最常用的创作状态、待处理信号和继续入口。',
    metrics: {
      activeProjects: {
        title: '活跃项目数',
        detail: '打开项目列表',
      },
      inFlight: {
        title: '在产章节',
        detail: '查看脉动看板',
      },
      consistency: {
        title: '一致性健康度',
        detail: '{{hard}} 硬冲突 · {{soft}} 软冲突 · {{overridden}} 例外',
        status: {
          healthy: '健康',
          needsAttention: '需关注',
        },
      },
      credits: {
        title: '信用点余额',
        detail: '查看计量计费',
      },
    },
    recent: {
      title: '最近编辑项目',
      description: '按更新时间排序，继续最近的创作现场。',
      genreFallback: '未设置体裁',
      empty: '还没有活跃项目',
      emptyHint: '新建一个项目后，这里会显示最近编辑入口。',
    },
    quickActions: {
      title: '快捷入口',
      description: '高频操作直接进工作区。',
      newProject: '新建项目',
      board: '看板',
      trash: '回收站',
    },
    errors: {
      projects: '项目数据加载失败。',
      pulse: '在产状态加载失败。',
      conflicts: '一致性状态加载失败。',
      credits: '信用点余额加载失败。',
    },
  },
  account: {
    changePassword: '改密码',
    changePasswordDescription: '更新当前账号的登录密码。',
    currentPassword: '当前密码',
    newPassword: '新密码',
    confirmPassword: '确认新密码',
    changingPassword: '修改中',
    passwordChangeSuccess: '密码修改成功',
    passwordChangeFailed: '密码修改失败',
    passwordUnavailable: '当前认证模式暂不支持修改密码。',
    passwordRequired: '请填写当前密码、新密码和确认密码。',
    passwordMismatch: '两次输入的新密码不一致。',
  },
  common: {
    zoom: '查看大图',
    logout: '退出登录',
    theme: '暗 / 亮',
    lang: 'EN',
    loading: '加载中…',
    workInProgress: '此工位 M1/M2 落地中',
    serviceError: '服务暂时不可用或网络异常',
    retry: '重试',
    create: '创建',
    cancel: '取消',
    close: '关闭',
    save: '保存',
    edit: '编辑',
    copy: '复制',
    copied: '已复制',
  },
  errors: {
    http: {
      401: '请先登录',
      403: '无权限访问',
      404: '资源不存在',
      429: '请求过于频繁',
      500: '服务异常请稍后重试',
      502: '网关错误',
      503: '服务暂不可用',
      unknown: '请求失败，请稍后重试',
    },
    // 用户可见错误文案的 SSOT：后端 message 仅供日志/调试，不会由 friendlyMessage 展示。
    // 修改 error code 的产品文案时，请在此处更新对应翻译。
    codes: {
		chapter_exists: '该章序已存在，请刷新并选择下一章。',
		invalid_genre: '请选择目录中的类型，或使用自定义类型。',
		compose_prerequisites: '请先生成通过审核的分镜和音频，再合成成片。',
      foreshadow_decision_required: '请为这些伏笔安排兑现卷、标长线或删除',
      not_ready: '服务正在启动，请稍后重试',
      dispatcher_unavailable: '服务暂时不可用，请稍后重试',
      chapter_service_unavailable: '章节服务暂时不可用，请稍后重试',
      memory_store_unavailable: '记忆服务暂时不可用，请稍后重试',
      config_error: '服务配置异常，请稍后重试',
      forbidden: '你没有权限执行此操作',
      unauthorized: '请先登录后再继续',
      project_budget_exceeded: "项目预算不足；本次按保守费用上界预估，实际费用可能更低。请调整预算或等待在途任务结算。",
      insufficient_credits: '信用点余额不足，请充值后重试',
      outline_not_confirmed: '请先确认章节大纲，再生成正文',
      foreshadow_no_payoff: '骨架里埋下的伏笔没有安排任何回收。请回到骨架规划，为它们指定回收的卷/章后再确认。',
      rate_limited: '请求过于频繁，请稍后重试',
      generation_failed: '生成失败，请稍后重试',
      video_station_disabled: '视频生成功能暂未开放',
      not_found: '资源不存在或已被移除',
      internal: '服务异常，请稍后重试',
      db_error: '服务异常，请稍后重试',
      invalid_captcha: '验证码错误或已过期',
      invalid_json: '请求内容格式不正确，请检查后重试',
      invalid_request: '请求内容不完整，请检查后重试',
      missing_fields: '请补全必填信息后重试',
      account_locked: '账号已被锁定，请联系管理员',
      redemption_code_used: '兑换码已被使用',
      username_exists: '用户名已存在，请换一个用户名',
      invalid_credentials: '用户名或密码不正确',
    },
    boundary: {
      title: '此区域暂时无法显示',
      description: '页面组件遇到异常。你可以刷新页面后重试，导航和其它区域仍可继续使用。',
      refresh: '刷新',
      chapterWorkspace: '章节工作区暂时无法显示',
    },
  },
  assetLibrary: {
    searchPlaceholder: '搜索资产',
    loadFailed: '资产库加载失败',
    empty: '暂无可展示资产',
    source: '来源',
    sourceChapter: '来源章节',
    chapterShort: '第 {{chapter}} 章',
    openExisting: '打开既有入口',
    types: {
      all: '全部',
      character: '角色',
      scene: '场景',
      prop: '道具',
      voice: '声线',
    },
    attributes: {
      role_type: '定位',
      appearance: '外观',
      visual_lock: '视觉锁',
      last_seen_chapter: '最近出现',
      scene_id: '场景 ID',
      intent: '意图',
      weather: '天气',
      lighting: '光线',
      override_reason: '锁定原因',
      scenes: '关联场景',
      strictness: '严格度',
      character: '角色',
      voice: '音色',
      builtin: '内建',
      gender: '性别',
      age_band: '年龄段',
      style: '风格',
      source: '来源',
      provider: '供应商',
      model: '模型',
      description: '描述',
    },
  },
  qualityGate: {
    unscored: '未评分',
    assessmentFailed: '评分失败',
    scoreShort: '质 {{score}}',
    scoreValue: '质量 {{score}}',
    regenerate: '重生成',
    regenerateQueued: '质量重生成已提交',
    emptyChapter: '当前章节没有可重生成的正文',
    loading: '正在读取评分历史',
    noHistory: '暂无评分历史',
    cardTitle: '章节质量评分',
    overall: '综合评分',
    suggestions: '建议',
    band: {
      excellent: '优秀',
      good: '良好',
      review: '待复核',
      weak: '偏弱',
      failed: '失败',
    },
  },
  billing: {
    title: '计量计费',
    description: '查看当前账号的作品用量、信用点余额和消费流水。',
    usage: {
      title: '用量概览',
      description: '按工位、日期和模型查看当前账号的信用点消耗。',
      dailyTitle: '本月每日消费趋势',
      dailyDescription: '本月每日信用点消耗，柱状表示单日总量，折线表示趋势。',
      byServiceTitle: '按工位',
      byServiceDescription: '各生产工位消耗的信用点占比。',
      byModelTitle: '按模型',
      monthCredits: '本月信用点',
      monthCreditsSubtitle: '当月累计消费',
      cumulativeCredits: '累计信用点',
      cumulativeCreditsSubtitle: '账户历史总消费',
      modelCredits: '模型信用点',
      modelCount: '模型数',
      month: '月份',
      creditsUnit: '信用点',
      serviceShareChart: '工位信用点占比图',
      sourceLocal: '本地',
      sourceCloud: '云端',
      colModel: '模型',
      colSource: '来源',
      colTokens: 'Tokens',
      colCredits: '信用点',
      inputTokens: '输入',
      outputTokens: '输出',
      cachedInputTokens: '缓存',
      partialTokenSplit: '部分历史数据无分列',
      empty: '暂无数据',
      retry: '重试',
      services: {
        text: '文字',
        screenplay: '剧本',
        storyboard: '分镜',
        image: '图像',
        audio: '音频',
        video: '视频',
      },
    },
    projects: {
      title: '作品概览',
      description: '按当前用户作品统计文字总量。',
      count: '作品数',
      totalWords: '文字总量',
      empty: '暂无作品。',
      error: '作品用量加载失败。',
      statusUnknown: '未知',
      table: {
        title: '标题',
        words: '字数',
        status: '状态',
      },
    },
    credits: {
      title: '信用点',
      description: '当前账号的计费余额。',
      available: '可用',
      balance: '余额',
      reserved: '预留',
      disabled: '未启用计费',
      error: '信用点余额加载失败。',
    },
    redeem: {
      title: '兑换码充值',
      placeholder: 'NF-XXXX-XXXX-XXXX-XXXX',
      submit: '兑换',
      required: '请输入兑换码。',
      success: '兑换成功，余额已刷新。',
      errors: {
        invalid: '兑换码无效。',
        used: '兑换码已被使用。',
        expired: '兑换码已过期。',
      },
    },
    payment: {
      title: '支付充值',
      checkout: '去支付',
      comingSoon: '支付即将上线',
      preregister: '预登记',
      preregistered: '已记录充值意向，当前版本不接真实支付。',
      packages: {
        starter: {
          title: '创作入门包',
          description: '适合短期试用图像、音频与视频工位。',
        },
        studio: {
          title: '工作室包',
          description: '适合连续生产章节资产的团队预留。',
        },
      },
    },
    ledger: {
      title: '流水',
      description: '最近的信用点增减记录。',
      empty: '暂无流水记录。',
      error: '信用点流水加载失败。',
      previous: '上一页',
      next: '下一页',
      range: '第 {{start}}-{{end}} 条',
      single: '第 {{index}} 条',
      table: {
        type: '类型',
        amount: '金额',
        balanceAfter: '变动后余额',
        createdAt: '时间',
      },
      types: {
        topup: '充值',
        consume: '消费',
        refund: '退款',
        hold: '预留',
        release: '释放预留',
        adjust: '调整',
      },
    },
  },
  admin: {
    title: '管理',
    subtitle: '集中管理需要 Admin Token 的系统级能力。Token 仅保存在当前浏览器本地存储中。',
    tokenTitle: 'Admin Token',
    tokenDescription: '管理功能需 Admin Token 二次验证(与登录账号双因子)。Token 仅存本地浏览器。',
    tokenLabel: 'Token',
    tokenPlaceholder: '输入 Admin Token',
    tokenConfiguredPlaceholder: '已保存(留空保持不变)',
    tokenConfigured: '已验证',
    tokenMissing: '未配置',
    tokenVerifying: '验证中',
    tokenInvalid: 'Token 无效',
    tokenRequired: '请输入 Admin Token',
    tokenSaved: 'Admin Token 已保存并开始验证',
    tokenCleared: 'Admin Token 已清除',
    saveToken: '保存并验证',
    clearToken: '清除',
    openModels: '模型设置',
    showToken: '显示 Token',
    hideToken: '隐藏 Token',
  },
  adminConsole: {
    forbiddenTitle: '无权访问管理后台',
    forbiddenDescription: '当前账号不是管理员，无法打开需要管理员权限的页面。',
    tokenMissingTitle: '需要先配置 Admin Token',
    tokenMissingDescription: '保存 Admin Token 后，用户管理、信用点充值和模型设置入口会在此控制台启用。',
    tokenVerifyingTitle: '验证 Token 中…',
    tokenVerifyingDescription: '正在向服务端确认 Admin Token 是否有效。',
    tokenInvalidTitle: 'Admin Token 不正确',
    tokenInvalidDescription: 'Admin Token 不正确，已拒绝访问管理功能。请重新输入正确 Token。',
    tabs: {
      users: '用户管理',
      usage: '用量看板',
      dashboard: '数据面板',
      observability: '日志与性能',
      credits: '信用点',
      models: '模型设置',
      storage: '存储配置',
      backup: '备份',
    },
    dashboard: {
      title: '数据面板',
      description: '一键打开管理数据面板，查看用户、生成链路、大模型健康、角色可路由与后端探活。',
      open: '打开数据面板',
    },
    storage: {
      title: '存储配置',
      description: '查看当前后端与目录映射。可快速进入存储连通性测试。',
      open: '打开存储配置',
    },
    users: {
      title: '用户管理',
      description: '搜索现有用户，调整信任等级、管理员身份与启用状态，并可重置密码。',
      searchPlaceholder: '搜索用户名、显示名或用户ID',
      search: '搜索',
      empty: '没有找到用户',
      emptyRange: '暂无用户',
      range: '第 {{start}}-{{end}} 条',
      single: '第 {{index}} 条',
      previous: '上一页',
      next: '下一页',
      yes: '是',
      no: '否',
      active: '启用',
      inactive: '停用',
      resetPassword: '重置密码',
      editTitle: '编辑用户',
      resetTitle: '重置用户密码',
      resetDescription: '为 {{username}} 设置新密码，并删除该用户现有会话。',
      newPassword: '新密码',
      newPasswordPlaceholder: '至少 8 位',
      adminOn: '管理员：是',
      adminOff: '管理员：否',
      activeOn: '状态：启用',
      activeOff: '状态：停用',
      updateSuccess: '用户已更新',
      resetSuccess: '密码已重置，已删除 {{count}} 个会话',
      columns: {
        username: '用户名',
        displayName: '显示名',
        trustLevel: '信任等级',
        isAdmin: '管理员',
        isActive: '状态',
        createdAt: '创建时间',
        actions: '操作',
      },
      errors: {
        invalidTrustLevel: '信任等级必须是大于等于 0 的整数',
        passwordTooShort: '新密码至少 8 位',
        lastAdminProtected: '不能降级或停用最后一个有效管理员',
        userNotFound: '用户不存在',
      },
    },
    credits: {
      title: '信用点充值',
      description: '给指定用户充值信用点；每次提交自动生成防重复标识。',
      userId: '用户ID',
      userIdPlaceholder: '搜索用户名或粘贴用户ID',
      userSearchLoading: '正在搜索用户…',
      userSearchEmpty: '没有找到匹配用户',
      userSearchMeta: '{{displayName}} · {{userId}}',
      amount: '数量',
      note: '备注',
      notePlaceholder: '可选，写入审计说明',
      submit: '充值',
      topUpSuccess: '信用点已充值',
      errors: {
        userRequired: '请输入用户ID',
        amountInvalid: '充值数量必须大于 0',
      },
    },
    observability: {
      perfTitle: '性能摘要',
      perfDescription: '复用 LLM 调用和用量事件记录，按模型与工位聚合延迟、成本和错误率。',
      logsTitle: '日志流',
      logsDescription: '查看最近的结构化服务日志，可按级别和关键字筛选。',
      empty: '暂无数据',
      logsLimited: '显示最近 {{count}} 条，共匹配 {{total}} 条。',
      metrics: {
        modelP95: '模型 95 分位',
        cost: '模型成本',
        slowest: '最慢请求',
        modelCount: '{{count}} 个模型',
      },
      filters: {
        level: '级别',
        allLevels: '全部级别',
        keyword: '关键字',
        keywordPlaceholder: '搜索消息或结构化字段',
        apply: '筛选',
      },
      columns: {
        time: '时间',
        level: '级别',
        component: '组件',
        requestId: '请求ID',
        message: '消息',
        model: '模型',
        p95: '95 分位',
        avg: '平均',
        errorRate: '错误率',
        cost: '成本',
      },
    },
    usage: {
      title: '成本与利润看板',
      description: '通过管理用量端点查看全局成本、信用点收入、利润和调用量。',
      byService: '按工位成本',
      byModel: '按模型成本',
      daily: '按日成本趋势',
      empty: '暂无用量数据',
      filters: {
        month: '月份',
        service: '工位',
        allServices: '全部工位',
        model: '模型',
        modelPlaceholder: '可选：按模型筛选',
        start: '开始',
        end: '结束',
      },
      metrics: {
        cost: '成本',
        margin: '利润',
        credits: '信用点',
        quantity: '调用量',
        tokens: 'Tokens',
      },
    },
    billing: {
      title: '完整计费控制台',
      description: '按总览、用户、明细、财务和充值兑换码管理平台计费。',
      empty: '暂无计费数据',
      unknown: '未知',
      credits: '信用点',
      exportCsv: '导出 CSV',
      selectUser: '请选择用户后查看数据',
      serviceShare: '工位占比',
      trendTitle: '按日成本、收入与毛利趋势',
      trendDescription: '收入按 100 信用点 = 1 USD 折算，用于管理口径对齐。',
      topUsers: 'Top N 用户消费排行',
      userAnalysis: '用户计费分析',
      userAnalysisDescription: '搜索用户并下钻余额、工位、模型、作品级用量和消费流水。',
      userSearchPlaceholder: '搜索用户名、显示名或用户ID',
      byService: '按工位',
      byModel: '按模型',
      byProject: '作品级用量',
      ledger: '消费流水',
      detailsTitle: '全平台用量明细',
      detailsDescription: '当前筛选条件下的用户、项目、工位、模型、成本、收入和毛利底账。',
      tabs: {
        overview: '计费总览',
        users: '用户分析',
        details: '用量明细',
        finance: '财务报表',
        wallet: '充值兑换码',
      },
      filters: {
        month: '月份',
        start: '开始',
        end: '结束',
        service: '工位',
        allServices: '全部工位',
        model: '模型',
        modelPlaceholder: '可选：按模型筛选',
        user: '用户',
        userPlaceholder: '可选：按用户筛选',
        project: '项目',
        projectPlaceholder: '可选：按项目筛选',
        includeInternal: '含内部账号',
        includeInternalHint: '默认排除内部账号；开启后统计含管理员/测试消耗（全口径）',
      },
      scope: {
        customer: '客户口径',
        customerHint: '默认排除内部账号',
        allIncluded: '全口径（含内部）',
        includesInternalHint: '当前含内部账号',
      },
      metrics: {
        quantity: '总用量',
        events: '{{count}} 次事件',
        cost: '总成本 USD',
        credits: '总收入信用点',
        revenue: '折合收入 USD',
        margin: '总毛利 USD',
        marginRate: '毛利率',
        internalCost: '内部使用成本（运营/研发）',
        internalCredits: '内部 {{credits}}',
      },
      columns: {
        user: '用户',
        project: '项目',
        service: '工位',
      },
      balance: {
        available: '可用余额',
        reserved: '预留余额',
      },
      finance: {
        monthlyCost: '月度成本汇总',
        dailyReport: '月度收入与毛利汇总',
        dailyDescription: '按日汇总成本、收入、毛利与毛利率。',
        ledgerReport: '账本流水',
        ledgerDescription: '选择用户后展示该用户的账本流水。',
      },
      wallet: {
        topUpTitle: '给用户充值',
        topUpDescription: '选择用户并输入信用点数量，提交时自动生成防重复标识。',
        amount: '金额',
        note: '备注',
        notePlaceholder: '可选，写入审计说明',
        topUp: '充值',
        topUpSuccess: '充值成功，新余额 {{balance}}',
        userRequired: '请输入用户ID',
        amountInvalid: '数量必须大于 0',
        codesTitle: '生成兑换码',
        codesDescription: '批量生成指定金额的兑换码，可设置有效期。',
        count: '数量',
        purpose: '用途',
        purposes: {
          sale: '售卖',
          marketing: '营销赠送',
          test: '测试',
          comp: '补偿',
        },
        expiresAt: '有效期',
        generateCodes: '生成兑换码',
        codesSuccess: '已生成 {{count}} 个兑换码',
        copy: '复制',
        copySuccess: '兑换码已复制',
      },
      csv: {
        date: '日期',
        time: '时间',
        userId: '用户 ID',
        userName: '用户名称',
        projectId: '项目 ID',
        service: '服务工位',
        model: '模型',
        unit: '用量单位',
        quantity: '用量',
        unitCost: '单位成本 USD',
        cost: '内部成本 USD',
        credits: '扣减信用点',
        revenue: '信用点折合 USD',
        margin: '毛利 USD',
        marginRate: '毛利率',
        count: '事件数',
        ledgerId: '流水 ID',
        type: '操作类型',
        creditDelta: '信用点变化',
        balanceAfter: '变动后余额',
        refJob: '关联任务',
        note: '参考说明',
        period: '账单周期',
        balance: '余额',
        available: '可用余额',
        reserved: '预留余额',
      },
      files: {
        usage: '平台用量明细',
        daily: '月度收入毛利',
        ledger: '账务流水',
        statement: '用户账单',
      },
      ledgerTypes: {
        consume: '消耗',
        topup: '充值',
        hold: '预留',
        release: '释放',
        refund: '退款',
        adjust: '调整',
        redeem: '兑换',
      },
    },
    models: {
      title: '模型设置',
      description: '模型配置仍由独立页面维护，可从这里进入现有模型设置页。',
      open: '打开模型设置',
    },
    backup: {
      title: 'SQLite 备份',
      description: '查看核心数据压缩包，创建备份，并暂存安全恢复。',
      run: '立即备份',
      passphraseLabel: '备份口令',
      passphrasePlaceholder: '请输入备份口令',
      savePassphrase: '保存口令',
      passphraseSaved: '备份口令已保存',
      passphraseRequired: '请输入备份口令',
      passphraseStatus: '口令状态：{{status}}',
      passphraseConfigured: '已设置',
      passphraseNotConfigured: '未设置',
      configSaved: '备份配置已保存',
      saveConfig: '保存配置',
      enabled: '启用',
      intervalLabel: '备份间隔',
      intervalRequired: '请输入备份间隔',
      coreIntervalPlaceholder: '例如：24h0m0s',
      assetsIntervalPlaceholder: '例如：168h0m0s',
      keepCount: '保留份数',
      keepNPositiveInteger: '保留份数需为正整数',
      targetLabel: '备份目标',
      targetPlaceholder: '选择目标',
      remoteStatus: '{{type}} 远端：{{status}}',
      remoteHealthy: '健康',
      remoteDegraded: '异常',
      remoteNotConfigured: '未配置',
      coreTitle: '核心数据备份配置',
      coreDescription: '数据库核心数据与元数据备份',
      assetsTitle: '资产备份配置',
      assetsDescription: '资产文件与媒体内容备份',
      assetsObjectStorage: '资产已在对象存储',
      assetsLocalDirectory: '本地资产目录备份',
      runSuccess: '备份已创建：{{name}}',
      labelPlaceholder: '可选标签',
      empty: '暂无备份',
      integrityOk: '完整性正常',
      integrityFailed: '完整性校验失败',
      integrityUnknown: '完整性未知',
      download: '下载',
      restore: '恢复',
      delete: '删除',
      uploadRestore: '上传恢复',
      deleteSuccess: '备份已删除',
      restoreTitle: '确认恢复',
      restoreUploadSource: '上传的恢复包',
      restoreWarning: '将覆盖当前全部数据；系统会先自动备份当前库，启动恢复失败时会自动回滚。',
      confirmLabel: '输入 RESTORE 确认恢复',
      confirmPlaceholder: '输入 RESTORE 确认',
      confirmRestore: '确认恢复',
      restoreMissing: '请选择一个备份',
      restoreStaged: '恢复已暂存，请重启后端生效',
      restartNow: '立即重启',
      restartRequested: '已请求后端重启',
      users: '用户数',
      projects: '项目数',
      currentStorageBackend: '当前存储后端：{{backend}}',
      storageBackendUnknown: '未配置',
      targets: {
        local: '本地存储',
        s3: '对象存储（S3）',
      },
      columns: {
        name: '文件名',
        time: '时间',
        size: '大小',
        integrity: '完整性',
        actions: '操作',
      },
    },
  },
  adminDashboard: {
    goBack: '返回管理主页',
    title: '数据中台',
    subtitle: '基于已落库数据和路由只读状态的运行健康看板。',
    loadFailed: '数据加载失败',
    empty: '暂无数据',
    unknown: '未配置',
    alerts: {
      title: '当前告警',
      items: {
        queueDead: {
          title: '检测到死信任务',
          detail: '队列 {{queue}} 有 {{value}} 个死信任务；这些任务不会自行完成。',
        },
        queueBacklog: {
          title: '队列积压超过阈值',
          detail: '队列 {{queue}} 有 {{value}} 个待处理任务，已超过配置阈值。',
        },
        failureConcentrated: {
          title: '死信原因高度集中',
          detail: '队列 {{queue}} 的原因 {{reason}} 占 {{share}}（{{samples}} 个样本），可能是单一系统故障。',
        },
        ttsPrimaryFailing: {
          title: '主用 TTS 正在失败',
          detail: '主用失败 {{primaryFailures}} 次；兜底已服务 {{fallbackServed}} 次。',
        },
      },
    },
    queues: {
      title: '任务队列状态',
      description: '实时展示待处理、租约中和死信任务；与页面现有的生成任务统计分开计算。',
      queue: '队列',
      ready: '待处理',
      leased: '租约中',
      dead: '死信',
      failureDominant: '主要失败原因',
      failureShare: '占比',
      failureSamples: '样本数',
      empty: '暂无队列数据',
    },
    users: {
      title: '用户',
      total: '全部用户',
      internal: '内部账号',
      admin: '管理员',
    },
    generation: {
      title: '生成链路健康',
      pending: '待处理',
      running: '运行中',
      done: '完成',
      failed: '失败',
      partial: '部分完成',
      needsReview: '待复核',
      successRate: '成功率',
      partialRate: '部分完成率',
      avgLatency: '平均单章耗时 {{value}} ms',
    },
    llmHealth: {
      title: 'LLM 调用健康',
      openModels: '打开模型设置',
      model: '模型',
      count: '调用数',
      successRate: '成功率',
      p90Latency: '九成延迟',
      tps: '每秒吞吐',
      baselineTps: '基线吞吐',
      state: '状态',
      degraded: '疑似后端降级，请查看基础设施告警',
      normal: '正常',
    },
    roles: {
      title: '角色可路由',
      role: '角色',
      routable: '可路由',
    },
    backendHealth: {
      title: '后端探活',
      description: '按模型后端健康历史记录统计正常、失败和未知状态。',
      ok: '正常',
      failed: '失败',
      unknown: '未知',
      openModels: '打开模型与探活设置',
    },
    storage: {
      title: '存储',
      description: '后端与桶配置',
      backend: '后端',
    },
  },
  modelSettings: {
    title: '模型设置',
    subtitle: '统一编辑各模态后端配置。保存只提交已修改字段；API Key 留空表示不改。',
    tokenMissingTitle: '需要 Admin Token',
    tokenMissingDescription: '请先在管理页保存 Admin Token，然后再打开模型设置。',
    goAdmin: '前往管理页',
    backToAdmin: '返回管理主页',
    loadFailed: '模型设置加载失败',
    defaultBackend: '默认后端',
    dbOverridden: '数据库覆盖',
    apiKeyStored: '已配置密钥',
    dirty: '未保存',
    emptyCategory: '后端没有返回此模态配置。',
    test: '测试连接',
    discover: '发现模型',
    testPassed: '连接测试通过',
    testFailed: '连接测试失败',
    healthOk: '{{count}} 个正常',
    healthFailed: '{{count}} 个异常',
    healthUnknown: '{{count}} 个未探活',
    healthDisabled: '{{count}} 个未启用',
    ttsFallbackStats: 'TTS 兜底触发 {{fallbackServed}} 次 / 主用失败 {{primaryFailures}} 次',
    ttsFallbackNotConfigured: '未配置兜底',
    backendDisabled: '未启用',
    discoverLoaded: '已发现 {{count}} 个模型',
    discoverEmpty: '没有发现模型，可手动输入',
    selectDiscoveredModel: '选择发现的模型',
    probeUnsupported: '不支持探活',
    probeUnsupportedHint: '该后端无探活端点, 非故障',
    noChanges: '没有需要保存的修改',
    savedHotReloaded: '已保存并即时生效',
    savedRestart: '已保存，可能需要重启后生效',
    apiKeyPlaceholder: '留空不修改',
    apiKeyHint: '留空不会提交 API Key；输入新值才会覆盖。',
    booleanTrue: '是',
    booleanFalse: '否',
    categories: {
      llm: '大模型',
      embed: '向量化',
      image: '图像',
      audio: '音频',
      asr: '语音识别',
      video: '视频',
      rerank: '重排',
      comfyui: '工作流出图',
    },
    categoryDescriptions: {
      llm: '文本生成后端，可分别编辑每个服务。',
      embed: '向量化后端配置，展示当前嵌入模型能力与维度。',
      image: '图像生成单后端配置。',
      audio: '音频生成单后端配置。',
      asr: '语音输入转写后端配置。',
      video: '视频工作流单后端配置。',
      rerank: '重排单后端配置，用于检索结果二次排序。',
      comfyui: 'ComfyUI 便捷配置，包含 Base URL 与模型文件字段。',
    },
    fields: {
      base_url: 'Base URL',
      endpoint: 'Endpoint',
      provider: 'Provider',
      model: 'Model',
      primary_model: '主模型',
      prompt_suffix: '纯文本后缀',
      primary_timeout_sec: '主超时(秒)',
      dim: '维度',
      workflow_template: '工作流模板',
      width: '宽度',
      height: '高度',
      fps: 'FPS',
      duration: '时长',
      steps: 'Steps',
      top_n: 'Top N',
      unet_gguf: 'UNet GGUF',
      clip_gguf: 'CLIP GGUF',
      vae: 'VAE',
      cfg: 'CFG',
      seed: 'Seed',
      api_key: 'API Key',
    },
    fieldHints: {
      prompt_suffix: '纯文本后缀(如统一风格词); 请勿填写 `<lora:...>` 标签',
    },
  },
  storageConfig: {
    title: '存储配置',
    subtitle: '编辑存储后端与路径映射，保存后重启服务生效。',
    backToAdmin: '返回管理主页',
    loading: '配置加载中…',
    loadFailed: '存储配置加载失败',
    currentConfig: '当前配置',
    configSummary: '数据库配置会覆盖配置文件默认值；密钥留空时保留现有值。',
    credentialTitle: '凭证说明',
    credentialDescription:
      '对象存储密钥仅提交到服务端加密保存，页面永不回显明文。资产签名密钥由服务端管理。',
    backend: '存储后端',
    s3Title: 'S3 连接',
    bucketsTitle: '存储桶',
    localRootsTitle: '本地根目录',
    assetSigningKeyConfigured: '已配置',
    tokenMissingTitle: '需要 Admin Token',
    tokenMissingDescription: '请先在管理页保存 Admin Token，再打开此页面。',
    goAdmin: '前往管理页',
    test: '连通性测试',
    testPassed: '连通正常',
    testFailed: '连通失败',
    restartRequired: '需重启生效',
    restartDescription: '配置已保存；重启管理服务后，运行中的存储实例才会使用新配置。',
    resetConfirm: '确认删除数据库中的存储配置并恢复配置文件默认值吗？',
    actions: {
      save: '保存',
      saving: '保存中…',
      test: '测试连通性',
      testing: '测试中…',
      reset: '恢复默认',
      resetting: '恢复中…',
      restart: '一键重启',
      restarting: '重启中…',
    },
    toast: {
      saveSuccess: '存储配置已保存',
      saveFailed: '存储配置保存失败',
      resetSuccess: '已恢复配置文件默认值',
      resetFailed: '恢复默认配置失败',
      restartSuccess: '重启请求已提交',
      restartFailed: '服务重启失败',
    },
    credentials: {
      accessKey: 'S3 访问密钥',
      secretKey: 'S3 私密密钥',
      keepPlaceholder: '留空保持不变',
      configured: '已配置',
      notConfigured: '未配置',
    },
    fields: {
      backend: '存储后端',
      s3Endpoint: '对象存储端点',
      s3Region: '对象存储区域',
      presignTTL: '预签名有效期(秒)',
      assetSigningKeyStatus: '资产签名密钥状态',
    },
    backends: {
      local: '本地存储',
      s3: '对象存储（S3）',
      garage: '兼容对象存储',
    },
    buckets: {
      image: '图片桶',
      audio: '音频桶',
      video: '视频桶',
      text: '文本桶',
    },
    local: {
      imageRoot: '图片根目录',
      audioRoot: '音频根目录',
      videoRoot: '视频根目录',
      textRoot: '文本根目录',
    },
    signingKeyConfigured: '已配置',
    signingKeyRandom: '未配置',
  },
  voiceInput: {
    record: '录音',
    stop: '停止 {{time}}',
    importAudio: '导入音频',
    disabledBadge: '未启用',
    adminTooltip: '管理员需配置并测试语音识别模型',
    preferenceOffTooltip: '语音输入已关闭',
    preference: '语音输入',
    tooShort: '录音太短,请说长一点',
    failed: '转写失败，请稍后重试',
    transcribed: '转写已填入',
    unsupported: '当前浏览器不支持录音',
    microphoneFailed: '无法访问麦克风',
    insertModes: {
      append: '追加',
      replace: '替换',
    },
  },
  branch: {
	 fork: '分叉新分支',
	 forkChapter: '分叉章序',
	 newName: '新分支名称',
	 forked: '新分支已创建',
	 forkFailed: '创建分支失败',
    title: '故事分支',
    subtitle: '可视化本故事的分叉与切换分支树。当前活跃分支会特别标记；点击其它节点可切换。',
    main: '主线',
    forkAt: '分叉于第{{value}}章',
    empty: '填写上方分支名称和章序，创建一条新的剧情分支。',
    loadFailed: '分支加载失败',
    switched: '已切换分支',
    switchFailed: '切换分支失败，请稍后重试',
    activeBranch: '当前分支：{{value}}',
    promoteHint: '先切换到要扶正的探索分支，再执行晋升。',
    promote: '晋升',
    promoted: '分支已晋升为新主线',
    promoteFailed: '分支晋升失败，请稍后重试',
    promoteConfirmTitle: '晋升为新主线',
    promoteConfirmDescription: '将“{{name}}”扶正为主干分支，并把旧主干归档。',
    promoteIrreversible: '这是高风险数据迁移。旧主干会被归档，该操作不可逆。',
    promoteConfirmAction: '确认晋升',
  },
  onboarding: {
    title: '首个成片引导',
    description: '用 3 步跑通从项目到第一条视频的最小闭环。',
    loadFailed: '引导状态加载失败，请稍后重试',
    status: {
      done: '已完成',
      current: '当前',
      todo: '待做',
    },
    steps: {
      project: {
        title: '建项目并确认骨架',
        description: '先建立故事容器，确认它能承载章节和生产资产。',
        action: '去项目',
      },
      chapter: {
        title: '生成 1 章和剧本/分镜',
        description: '完成一章正文，并产出剧本与分镜资产。',
        action: '去章节',
      },
      film: {
        title: '合成首个成片',
        description: '进入视频工位，把可用素材合成为第一条成片。',
        action: '去合成',
      },
    },
  },
  project: {
    title: '项目',
    subtitle: '管理故事项目、章节骨架与生成能力偏好',
    new: '新建项目',
    selectProject: '选择项目',
    searchProject: '搜索项目标题',
    noProjectResults: '没有匹配的项目',
    recentProjects: '最近',
    allProjects: '全部项目',
    allProjectsAggregate: '全部项目',
    name: '项目标题',
    titleRequired: '请输入项目标题',
    titleTooLong: '项目标题最多 120 字',
    description: '简介',
    descriptionTooLong: '简介最多 800 字',
    genre: '类型',
    genreTooLong: '类型最多 80 字',
    status: '状态',
    words: '字数',
    wordsGenerated: '已生成',
    wordsTarget: '目标',
    wordsUnit: '字',
    sort: {
      label: '项目排序',
      updated: '最近更新',
      title: '标题',
      words: '字数',
      chapters: '章节数',
    },
    targetWords: '目标字数',
    targetWordsPositive: '目标字数必须大于 0',
    chapters: '章节',
    empty: '暂无项目',
    emptyHint: '创建一个故事项目后，章节树、内容工位和设定面板会在这里展开。',
    createDescription: '先建立项目容器，后续阶段会在项目内接入卷章树和文本生成闭环。',
    creating: '创建中',
    validationFailed: '请检查项目表单',
    backToProjects: '返回项目',
    created: '项目已创建',
    saved: '项目已保存',
    delete: '删除项目',
    moveToTrash: '移到回收站',
    deleteMoved: '项目已移到回收站',
    deleteFailed: '项目删除失败，请稍后重试',
    deleteConfirmTitle: '移到回收站',
    deleteConfirmDescription: '“{{title}}”将移到回收站，7 天内可恢复。',
    noDescription: '暂无简介',
    unknown: '未设置',
    chapterCount: '{{value}} 章',
    wordsValue: '{{value}} 字',
    modalitiesTitle: '生成能力',
    modalities: {
      screenplay: '剧本',
      audio: '音频',
      image: '图像',
      video: '视频',
    },
    modalitiesText: '文字',
    modalitiesSaved: '生成能力已保存',
    modalitiesSaveFailed: '生成能力保存失败，请稍后重试',
    titleSaveFailed: '项目标题保存失败，请稍后重试',
    generateNow: '即时生成章节',
    trash: {
      title: '回收站',
      subtitle: '已删除项目会保留 7 天；过期项目会在打开回收站时自动彻底删除。',
      deletedAt: '删除时间',
      remainingDays: '剩余时间',
      remainingDaysValue: '{{count}} 天',
      actions: '操作',
      restore: '恢复',
      restoreSuccess: '项目已恢复',
      restoreFailed: '项目恢复失败，请稍后重试',
      purge: '彻底删除',
      purgeSuccess: '项目已彻底删除',
      purgeFailed: '项目彻底删除失败，请稍后重试',
      purgeConfirmTitle: '彻底删除项目',
      purgeConfirmDescription: '“{{title}}”将被永久删除；用量流水会保留用于审计，其余项目数据不可恢复。',
      empty: '回收站为空',
      emptyHint: '移到回收站的项目会在这里显示，7 天内可恢复。',
      searchPlaceholder: '搜索回收站项目…',
      noMatch: '没有匹配的回收站项目',
    },
    wizard: {
      modeLabel: '创作模式',
      easyMode: '简易',
      advancedMode: '高级',
      description: '按创作因果顺序补足项目定义；除一级题材和目标字数外都可跳过，之后还能继续发展。',
      easy: {
        description: '先说出故事的火种，AI 会整理成一份可修改的项目草案。',
        ideaLabel: '说说你想写什么',
        ideaPlaceholder: '例如：一个失忆邮差收到一封写给明日死者的信。',
        ideaRequired: '请先说说你想写什么',
        lengthLabel: '篇幅',
        start: '开始创作',
        drafting: '正在整理故事',
        summaryTitle: 'AI 帮你定了这些',
        fallbackHint: '这次只整理出了题材方向。选一个题材即可创建，其他内容之后再补。',
        chooseGenre: '选择题材',
        createProject: '创建项目',
        advanced: '高级设置',
        groups: {
          basic: '基本信息',
          world: '世界观',
          protagonist: '主角',
          antagonist: '反派',
        },
      },
      autopilot: {
        title: '自动写作',
        targetWords: '目标字数',
        chapterWords: '每章约写',
        enable: '创建后自动写完第一卷',
        enableHint: '默认关闭；开启后系统会先生成并确认规划，再开始逐章写作。',
        estimating: '正在计算规模与信用点',
        estimateUnavailable: '填写目标字数、每章字数和题材后显示估算。',
        layout: '全书 {{chapters}} 章 · {{volumes}} 卷',
        firstVolume: '第一卷 {{chapters}} 章 · 约 {{words}} 字',
        credits: '预计 {{low}}–{{high}} 信用点',
        checkpoints: '写完第 1 / 2 / 3 章和第 {{end}} 章会停下确认',
        retry: '重试当前步骤',
        failedStage: '{{stage}}失败，已创建项目不会回滚，可重试当前步骤。',
        stages: {
          create_project: '正在创建项目…',
          propose_skeleton: '正在生成骨架…',
          confirm_skeleton: '正在生成逐章大纲…',
          confirm_outlines: '正在确认大纲…',
          start_autopilot: '正在启动自动写作…',
        },
        stageNames: {
          create_project: '创建项目',
          propose_skeleton: '生成骨架',
          confirm_skeleton: '生成逐章大纲',
          confirm_outlines: '确认大纲',
          start_autopilot: '启动自动写作',
        },
      },
      coreTheme: '核心立意',
      coreThemeHint: '作品最想反复追问或证明的东西，可先留空。',
      coreThemePlaceholder: '例如：人在获得力量后，是否还能守住最初的善意。',
      aiCoreTheme: 'AI 提炼立意',
      contentType: '内容类型',
      lengthForm: '长度 / 体裁',
      contentLanguage: '作品语言',
      contentLanguageHint: 'AI 生成骨架与正文使用的语言，独立于界面显示语言，创建后可在章节中单独覆盖。',
      cascadeThreshold: '自动级联阈值',
      cascadeStopAt: '自动级联终点',
      cascadeCostTitle: '成本预估',
      cascadeCostEstimate: '自动级联到 {{station}} 工位预计消耗约 {{tokens}} Tokens。',
      cascadeSaveFailed: '项目已创建，但级联策略保存失败，可在项目详情页补全。',
      worldSaveFailed: '项目已创建，但世界设定保存失败，可在项目详情页补全。',
      cascadeThresholds: {
        passed_only: '仅合格自动',
        review_ok: '待复核也自动',
        manual: '全手动',
      },
      contentTypes: {
        fiction: '虚构',
        nonfiction: '非虚构（未来支持）',
      },
      lengthForms: {
        poetry: '诗词（未来支持）',
        short: '短篇',
        medium: '中篇（未来支持）',
        long: '长篇',
      },
      axisHint: '当前支持虚构短篇与长篇；非虚构、诗词和其他体裁已预留接口。',
      genrePlaceholder: '选择一级题材',
      secondaryDrivers: '二级驱动力',
      secondaryDriversPlaceholder: '选择驱动故事前进的力量',
      selectedDriverCount: '已选 {{count}} 个驱动力',
      fallbackTitle: '{{label}}项目',
      untitledProject: '未命名项目',
      driverSearch: '搜索驱动力',
      driverEmpty: '没有匹配的驱动力',
      recommended: '推荐',
      removeDriver: '移除驱动力',
      logline: '一句话梗概',
      loglineHint: '用一句话说明主角、目标、阻力与独特看点。',
      loglinePlaceholder: '当一个处在低谷的主角获得异常机会，他必须在更大的代价到来前完成目标。',
      aiLogline: 'AI 提炼一句话梗概',
      worldRules: '世界规则',
      titlePlaceholder: '可留空，将从题材或一句话梗概自动生成',
      descriptionPlaceholder: '卖点、画面、开局念头或任何暂存想法',
      protagonistName: '主角名',
      protagonistNameEn: '主角英文名',
      protagonistMotivation: '主角动机',
      protagonistInnerFlaw: '主角缺口 / 内在缺陷',
      protagonistIdentity: '主角身份 / 起始处境',
      antagonistSource: '对抗源',
      toneKeynote: '基调',
      perspectivePlaceholder: '例如：第三人称有限视角 / 第一人称回忆',
      aiFailed: 'AI 建议生成失败，请稍后重试',
      aiSuggestions: 'AI 建议',
      aiLlmSource: '来自本地模型的多角度建议；采纳后仍可继续编辑。',
      aiFallbackSource: '本次使用题材模板兜底建议；采纳后仍可继续编辑。',
      useSuggestion: '填入',
      discardSuggestions: '弃用',
      validation: {
        genreRequired: '请选择一级题材',
        coreThemeTooLong: '核心立意最多 500 字',
        loglineTooLong: '一句话梗概最多 600 字',
        antagonistTooLong: '对抗源最多 300 字',
        toneTooLong: '基调最多 200 字',
        perspectiveTooLong: '叙事视角最多 120 字',
      },
    },
  },
  novelImport: {
    importNovel: '导入小说',
    kicker: '旧稿导入',
    title: '导入小说',
    subtitle: '上传 TXT/Markdown/FDX/Fountain 或粘贴正文，先预览章节切分，再确认创建项目和章节。',
    sourceTitle: '上传或粘贴',
    sourceDescription: '支持纯文本、Markdown、Final Draft FDX 与 Fountain；预览不会创建项目。',
    upload: '上传文件',
    uploadHint: '支持 TXT / Markdown / FDX / Fountain，也可以直接粘贴正文',
    limitHint: '支持 TXT/Markdown/FDX/Fountain，最大约 500 万字 / 15MB；GBK/UTF-8 自动识别。',
    encodingLabel: '编码：{{encoding}}',
    encodingConverted: '检测到 GBK/GB2312 编码，已自动转码',
    textLabel: '正文',
    textPlaceholder: '粘贴完整小说正文，或上传 TXT/Markdown 文件后在这里编辑。',
    textStats: '已输入 {{count}} 字',
    nearLimitHint: '接近上限',
    overLimitHint: '已超过 500 万字上限',
    metaTitle: '项目信息',
    metaDescription: '确认导入时会用这些信息创建新项目。',
    titlePlaceholder: '例如：长夜余火',
    genrePlaceholder: '选择模板题材或输入自定义题材',
    advancedTitle: '分章设置',
    advancedDescription: '修改正则或 Markdown 标题开关后，可重新预览重切。',
    customRegex: '自定义分割正则',
    customRegexPlaceholder: '例如：^第[一二三四五六七八九十百千万\\d]+章',
    allowMarkdownHeading: '识别 Markdown 标题',
    preview: '预览',
    confirm: '确认导入',
    previewTitle: '章节预览',
    previewDescription: '确认章节数、标题和正文片段后再导入。',
    chapterCount: '{{count}} 章',
    strategy: '策略：{{value}}',
    strategyBuiltin: '按章节标题智能分章',
    strategyCustom: '自定义分章规则',
    advancedPreview: '高级',
    regex: '分章规则原文：{{value}}',
    chapterLine: '第 {{index}} 章：{{title}}',
    wordCount: '{{count}} 字',
    expandHint: '展开 / 收起',
    screenplay: {
      title: '剧本结构',
      description: '本次导入包含从 {{format}} 解析出的场景、角色对白和动作段落。',
      scene: '场景',
      sceneCount: '{{count}} 场',
      dialogueCount: '{{count}} 句对白',
      characters: '角色',
      chapterStats: '{{scenes}} 场 / {{dialogues}} 句对白',
      unknownSetting: '未命名场景',
    },
    emptyPreview: '还没有预览',
    emptyPreviewHint: '输入正文后点击预览，系统会展示章节切分结果。',
    imported: '导入成功，共 {{count}} 章',
    errors: {
      emptyText: '请先上传文件或粘贴正文',
      readFile: '文件读取失败，请重试',
      noChapters: '未识别到章节，试试自定义正则',
      tooLarge: '内容过大',
      fileTooLarge: '文件过大 (>15MB)，请分卷导入',
      textTooLarge: '正文超过 500 万字上限，请分卷导入',
      generic: '导入失败，请稍后重试',
    },
  },
  detail: {
    author: '作者',
    settingsMode: '设定模式',
    settingsEasy: '简易',
    settingsAdvanced: '高级',
    worldExtras: '补充设定 (时代 / 地点 / 氛围)',
    loadFailed: '项目加载失败',
    chaptersTab: '章节',
    skeletonTab: '规划',
    gameplayTab: '玩法',
    productionPipelineTab: '成品流水线',
    ingestReviewTab: '实体审核',
    assetLibraryTab: '资产库',
    storylinesTab: '规划线',
    storyStateTab: '故事状态',
    characterStatesTab: '角色状态',
    relationGraphTab: '关系图',
    chapterTree: '卷章树',
    chapterTreeHint: '支持按卷章快速定位和管理章节',
    chapterNode: '第 {{value}} 章',
    chapterEmpty: '暂无章节。规划产出的是逐章大纲，章节节点在正文生成后才出现——点右上角「新章节」即可开始，已规划的大纲会自动带入表单。',
    contentWorkspace: '内容工作区',
    contentWorkspaceHint: '集中处理阅读、生成和局部改写',
    overview: '概览',
    reader: '阅读',
    pipeline: '脉动',
    outlineMode: '大纲模式',
    narrativePerspective: '叙事视角',
    contentPlaceholderTitle: '内容区壳已就绪',
    contentPlaceholderBody: '选择章节后可在这里查看正文、生成状态和改写结果。',
    readerPlaceholder: '选择章节后可进入沉浸阅读并调整阅读显示。',
    pipelinePlaceholder: '章节工位状态会在脉动看板中汇总展示。',
    settingsRoles: '设定 / 角色',
    settingsRolesHint: '结构化设定卡和角色资产会在这里集中管理',
    worldSettings: '世界设定',
    projectDefinition: '项目定义',
    timePeriod: '时代',
    location: '地点',
    atmosphere: '氛围',
    worldRules: '世界规则',
    savingSettings: '保存中',
    settingsSaved: '设定已保存',
    settingsSaveFailed: '设定保存失败，请稍后重试',
    rolesPlaceholder: '角色卡、世界规则和资产入口会在这里集中展示。',
    cascadePolicy: {
      simpleTitle: '自动生成到哪里',
      presets: { text: '只写文字', storyboard: '出到分镜', pages: '出到单格图' },
      customPreset: '当前使用自定义策略；选择预设将同时更新放行条件和终点。',
      pagesHint: '自动生成到单格图；成品页需在合页工位手动生成。',
      simpleStop: '停下, 等我决定',
      simpleAuto: '自动继续',
      simpleUntil: '一直做到',
      simpleStopHint: '每个工位产出后都会停下, 由你点击才进入下一步。',
      title: '生成级联策略',
      description: '控制质量门达到何种状态后自动继续，以及流水线自动运行到哪个工位。',
      saved: '级联策略已保存',
      saveFailed: '级联策略保存失败，请稍后重试',
    },
    softConsistency: {
      title: '软一致性反馈',
      master: '软一致性反馈',
      masterHint: '控制此项目是否启用软性一致性检查。',
      ooc: '人设偏离',
      oocHint: '标记人物行为、语气或能力边界的轻微偏移。',
      setting: '设定一致',
      settingHint: '标记世界设定、规则和事实的软性偏差。',
      emotion: '情绪连贯',
      emotionHint: '标记角色情绪弧线和场景情绪承接问题。',
      experimental: '实验性',
      globallyDisabled: '部署配置未启用软一致性反馈，当前项目开关不可用。',
      loadFailed: '软一致性反馈设置加载失败。',
      saved: '软一致性反馈设置已保存',
      saveFailed: '软一致性反馈设置保存失败，请稍后重试',
    },
    projectSkills: {
      title: '项目技能',
      empty: '当前项目没有可用技能。',
      loadFailed: '项目技能设置加载失败。',
      saved: '项目技能设置已保存',
      saveFailed: '项目技能设置保存失败，请稍后重试',
    },
    pipelineViewer: {
		chapter: '章节',
      title: '成品流水线',
      subtitle: '第 {{chapter}} 章 · {{title}}',
      selectChapter: '先在章节树选择一个章节，再查看剧本、分镜、图像、音频和视频资产。',
      notGenerated: '未生成',
      loadFailed: '资产加载失败',
      regenerate: '重新生成',
      openWorkbench: '打开工作台',
      queued: '已入队',
      regenerateFailed: '重新生成失败，请稍后重试',
      noCharacterTarget: '当前项目没有可生成设计图的角色',
      cascadePolicy: {
        title: '自动级联终点',
        scope: '项目级设置',
        description: '控制本项目章节正文通过后自动级联到哪个工位；选择文字则不会触发下游工位。',
        costTitle: '成本预估',
        costEstimate: '自动级联到 {{station}} 工位预计消耗约 {{tokens}} Tokens。',
        saved: '自动级联终点已保存',
        saveFailed: '自动级联终点保存失败，请稍后重试',
      },
      compose: {
		missing: '合成前还需要：{{items}}',
        submit: '合成成片',
        done: '成片合成完成',
        failed: '成片合成失败，请稍后重试',
        aspectLandscape: '16:9',
        aspectPortrait: '9:16',
        bgmNone: '无背景音乐',
      },
      credits: {
        insufficient: '余额不足，生成前请先充值或兑换信用点。',
        topUp: '去充值',
        videoConfirmTitle: '确认生成视频',
        videoConfirmDescription: '{{credits}}，视频生成消耗较高，确认后已消耗信用点不可退。',
        videoConfirmSubmit: '确认消耗并生成',
      },
      sceneFallback: '场景 {{index}}',
      unknownSpeaker: '未知角色',
      panelNo: '镜头 {{index}}',
      panelImageAlt: '第 {{index}} 个分镜图',
      poolGallery: {
        zoom: '查看大图',
        replay: '复现此候选',
        replayWaiting: '尚未收到复现结果，请在任务看板查看进度或稍后刷新',
        seed: '种子 {{seed}}',
        styles: { manga: '漫画', anime: '动画', watercolor: '水彩', realistic: '写实', ink_wash: '水墨', comic: '美漫' },
        title: '候选池',
        count: '{{count}} 张',
        primary: '主图',
        score: '评分 {{score}}',
        useAsPrimary: '设为主图',
        selected: '已切换主图',
        selectFailed: '切换主图失败，请稍后重试',
        selectCandidate: '选择排名 {{rank}} 的候选图',
        candidateAlt: '候选图 #{{rank}}',
      },
      shotType: '景别',
      composition: '构图',
      dialogueBubbles: '气泡',
      narrationBox: '旁白',
      chapterImageAlt: '章节图',
      characterDesignAlt: '{{name}} 角色设计图',
      designNotReady: '暂无角色设计图',
      designGenerating: '正在生成角色设计图',
      generateDesign: '生成设计图',
      designViews: {
        front: '正面',
        side: '侧面',
        back: '背面',
      },
      mediaUnsupported: '当前浏览器不支持此媒体播放。',
      status: {
        pending: '等待中',
        running: '运行中',
        done: '完成',
        needs_review: '待审核',
        failed: '失败',
      },
      audioWorkbench: {
        narratorVoice: '旁白声',
        characterVoices: '角色音色',
        speechRate: '语速',
        configDefault: '使用全局配置',
        customVoicePlaceholder: '自定义音色标识',
      },
      stations: {
        screenplay: {
          title: '剧本',
          description: '按场景展示旁白、动作和对白。',
        },
        storyboard: {
          title: '分镜',
          description: '查看分镜镜头、构图说明和已渲染画面。',
        },
        panel_image: {
          title: '章节图',
          description: '展示章节配图原始资源画廊。',
        },
        character_design: {
          title: '角色设计图',
          description: '展示已生成的角色三视图或设计图。',
        },
        audio: {
          title: '音频',
          description: '播放整章旁白和对白合成音频。',
        },
        video: {
          title: '视频',
          description: '播放由分镜和音频组装的章节视频。',
        },
      },
      sketchReview: {
        loadFailed: '草图确认加载失败',
        updateFailed: '草图更新失败',
        confirmFailed: '草图确认失败',
        rendered: '草图已生成',
      },
    },
  },
  workbench: {
	 pipelineHint: '在成品流水线查看资产与生成状态。',
	 openPipeline: '打开成品流水线',
    backToProject: '返回项目',
    chapterLabel: '第 {{number}} 章 · {{title}}',
    chapterUnavailable: '章节信息暂不可用',
    versionCurrent: '当前版本',
    configJson: '配置内容',
    saveConfig: '保存配置',
    loadFailed: '工作台加载失败',
    resolvedConfig: '合并后配置',
    configDefault: '使用配置默认',
    scope: {
      project: '项目默认',
      chapter: '章节覆盖',
    },
    toast: {
      saved: '工作台配置已保存',
      saveFailed: '工作台配置保存失败',
    },
    screenplay: {
      style: '创作风格',
      customStylePlaceholder: '输入自定义风格',
      length: '篇幅',
      dialogueDensity: '对白密度',
      pov: '叙事视角',
    },
    storyboard: {
      shotDensity: '分镜密度',
      preferredShotTypes: '偏好景别',
      cameraLanguage: '镜头语言',
      customCameraLanguagePlaceholder: '输入自定义镜头语言',
      styleLock: '风格锁定',
      customStyleLockPlaceholder: '输入风格锁定描述',
      sketchReviewEnabled: '启用线稿草图确认',
    },
    panelImage: {
      model: '模型',
      size: '尺寸',
      seedStrategy: '随机种子策略',
      seedDeterministic: '确定性',
      seedFixed: '固定值',
      seedPlaceholder: '输入整数随机种子',
      stylePreset: '风格预设',
      styleLockArtStyle: '美学锁：画风',
      styleLockArtStylePlaceholder: '如 电影感动画、齐马蓝美学',
      styleLockPalette: '美学锁：调色板',
      styleLockPalettePlaceholder: '如 冷色调深蓝主导, 高对比',
      styleLockQuality: '美学锁：质量词',
      styleLockQualityPlaceholder: '如 杰作品质、高清细节',
      styleLockNegative: '美学锁：画面禁区',
      styleLockNegativePlaceholder: '如 低质量、多余手指',
      configDefault: '使用配置默认',
    },
    preview: {
      title: '预览',
      subtitle: '工位渲染接线留给后续阶段',
      placeholder: '预览占位',
    },
    versions: {
      title: '版本',
      subtitle: '版本历史接线留给后续阶段',
      placeholder: '版本历史占位',
    },
    stations: {
      chapter_text: '文字工作台',
      screenplay: '剧本工作台',
      storyboard: '分镜工作台',
      panel_image: '出图工作台',
      audio: '声音工作台',
      video: '视频工作台',
    },
  },
  sketchReview: {
    title: '线稿草图确认',
    subtitle: '基于分镜空间意图生成结构化草图，不调用出图服务。',
    empty: '暂无草图帧',
    panelNo: '镜头 {{index}}',
    confirmAll: '确认全部',
    renderSketch: '生成草图',
    rerenderPanel: '重渲此镜头',
    thumbnailPending: '尚未生成草图',
    thumbnailAlt: '真实草图缩略图',
    vlmTitle: '视觉评估',
    vlmScore: '评分 {{score}}',
    vlmIssueFallback: '构图验证未通过',
    pool: {
      title: '草图候选',
      count: '{{count}} 张',
      primary: '主草图',
      score: '{{score}} 分',
      useAsPrimary: '设为主草图',
      selectCandidate: '选择第 {{rank}} 个草图候选',
      candidateAlt: '草图候选 {{rank}}',
    },
    slot: '位置',
    depth: '景深',
    gaze: '视线',
    posture: '姿态',
    status: {
      pending: '待确认',
      confirmed: '已确认',
      modified: '已修改',
    },
  },
  gameplay: {
    advancedMode: '高级模式',
    saving: '保存中',
    unset: '未设置',
    weightHint: '该维度在整体玩法配置中的强调权重(0-100%)。越高表示这本书越突出这个维度; 用于引导生成时的侧重。',
    profile: {
      title: '玩法档案',
      description: '基础模式查看 5 维玩法概览，高级模式微调全局目标权重。',
      templatePlaceholder: '选择玩法模板',
      coreLoopDesc: '核心循环',
      readerAppetite: '读者期待',
      empty: '当前项目还没有玩法档案；选择模板即可创建。',
      reset: '重置',
      saved: '玩法档案已保存',
      saveFailed: '玩法档案保存失败，请稍后重试',
    },
    chapter: {
      title: '章节目标微调',
      subtitle: '第 {{chapter}} 章 · {{title}}',
      selectChapter: '先在章节树选择一个章节，再微调该章玩法目标。',
      saveTarget: '保存目标',
      saved: '章节玩法目标已保存',
      saveFailed: '章节玩法目标保存失败，请稍后重试',
      pendingState: '保存后该章玩法状态会回到等待中，等待后续观测刷新。',
      status: '当前状态：{{status}}',
    },
    dimensions: {
      coreLoop: {
        label: '核心循环',
        hint: "故事反复驱动读者的核心爽点模式(如碾压/升级打脸/无限流)。决定这本书的主要'爽感引擎'。",
      },
      agency: {
        label: '掌控轴',
        hint: '主角对局势的掌控程度: 强掌控=主角主导碾压对手; 被动应对=被形势推着走; 主动推进=主动出击布局。',
      },
      info: {
        label: '认知差',
        hint: '读者与角色间的信息差, 制造张力: 公开信息=读者角色同步; 隐藏真相=读者蒙在鼓里; 戏剧性反讽=读者比角色先知道。',
      },
      social: {
        label: '社交参照',
        hint: '主角所处的社会关系框架/参照群体(如宗门/单人/家族), 影响人物互动与冲突来源。',
      },
      reward: {
        label: '奖励结构',
        hint: '爽点与奖励的发放节奏: 即时兑现=马上给爽点; 延迟满足=铺垫后爆发。影响读者追更节奏。',
      },
    },
    trajectory: {
      title: '实时弧线预览',
      description: '纯 SVG 展示跨章目标、观测与评分曲线。',
      empty: '暂无玩法轨迹数据。',
      loadFailed: '玩法轨迹加载失败。',
      series: {
        target_core: '目标核心',
        observed_core: '观测核心',
        target_payoff: '目标回报',
        observed_payoff: '观测回报',
        score: '评分',
      },
    },
    values: {
      upgrade_faceslap: '升级打脸',
      sign_in: '签到奖励',
      mystery: '谜团',
      farming: '种田经营',
      scheme: '权谋布局',
      domination: '霸道碾压',
      infinite: '无限流',
      rebirth_revenge: '重生复仇',
      hidden_dev: '苟道发育',
      survival: '生存压力',
      reactive: '被动应对',
      proactive: '主动推进',
      dominant: '强掌控',
      hidden: '隐藏布局',
      open: '公开信息',
      dramatic_irony: '戏剧性反讽',
      hidden_truth: '隐藏真相',
      solo: '单人',
      sect: '宗门',
      court: '朝堂',
      city: '城市',
      team: '小队',
      immediate: '即时兑现',
      delayed: '延迟兑现',
      layered: '层层兑现',
      cliff: '悬崖式兑现',
    },
    valueHints: {
      upgrade_faceslap: '主角不断变强并反击轻视者，经典升级流爽点。',
      sign_in: '通过签到或周期奖励稳定获得资源，逐步滚起优势。',
      mystery: '围绕未解之谜推进探索，靠线索和揭示制造牵引。',
      farming: '低冲突，侧重经营发展、建设积累和长期成长。',
      scheme: '以谋略算计推进局势，强调布局、博弈和智斗。',
      domination: '主角以压倒性实力碾压对手，强调爽感与掌控力。',
      infinite: '主角在多个副本或世界间闯关求生，持续面对新规则。',
      rebirth_revenge: '主角带记忆重生，复仇改命并重写关键选择。',
      hidden_dev: '低调隐藏实力猥琐发育，积累到关键时刻爆发。',
      survival: '高压求生，资源稀缺，重点制造持续危机感。',
      reactive: '角色主要被事件推动，应对外部压力和突发变化。',
      proactive: '角色主动设定目标并推动行动，节奏更有进攻性。',
      dominant: '角色掌控局势和选择权，强调主动压制与调度。',
      hidden: '关键信息或计划暂时隐藏，后续通过揭示形成反转。',
      open: '重要信息公开透明，冲突更多来自选择、立场和行动。',
      dramatic_irony: '读者知道角色不知道的信息，用认知差制造张力。',
      hidden_truth: '真相被遮蔽，剧情通过接近真相持续推进。',
      solo: '聚焦单人行动和个人成长，外部协作较少。',
      sect: '以宗门、门派或组织层级为参照，强调身份与资源。',
      court: '以朝堂权力结构为参照，强调政治站队和权力流动。',
      city: '以城市社会网络为参照，强调市井、势力和公共事件。',
      team: '以小队协作推进，强调分工、羁绊和团队战术。',
      immediate: '奖励很快兑现，适合短周期爽点和快速反馈。',
      delayed: '奖励延后兑现，通过期待和铺垫提升回报感。',
      layered: '奖励分多层逐步兑现，形成连续升级和连锁满足。',
      cliff: '奖励或危机卡在悬念点，推动读者继续读下一段。',
    },
  },
  acts: {
    title: '幕结构',
    subtitle: '手动维护三幕边界与中点章节。',
    persisted: '已保存',
    default: '默认',
    loadFailed: '幕结构加载失败',
    empty: '当前项目暂无可编辑幕结构。',
    actLabel: '第 {{act}} 幕',
    save: '保存幕结构',
    fields: {
      start: '起始章',
      end: '结束章',
      midpoint: '中点章',
      enabled: '启用',
    },
    roles: {
      setup: '开端',
      confrontation: '对抗',
      resolution: '结局',
    },
    messages: {
      saved: '幕结构已保存',
      saveFailed: '幕结构保存失败',
    },
  },
  storylines: {
    title: '规划线',
    subtitle: '管理长期主线、支线承诺和章节级权重。',
    newStoryline: '新建线',
    newSubplot: '新建支线',
    loadFailed: '规划线加载失败',
    empty: '还没有规划线。',
    noSubplots: '这条线下还没有支线。',
    priority: '优先级 {{priority}}',
    weightsTitle: '第 {{chapter}} 章权重',
    convergenceNode: '收束',
    saveWeights: '保存权重',
    createStoryline: '创建规划线',
    editStoryline: '编辑规划线',
    createSubplot: '创建支线',
    editSubplot: '编辑支线',
    deleteStoryline: '删除规划线',
    deleteSubplot: '删除支线',
    fillSubplot: '进入填坑',
    detonateSubplot: '引爆',
    confirmDeleteStoryline: '删除规划线“{{name}}”？',
    confirmDeleteSubplot: '删除支线“{{title}}”？',
    storylineDialogDescription: '定义项目需要持续追踪的长期叙事线。',
    subplotDialogDescription: '定义埋点、目标回收章节和收束章节。',
    subplotMeta: '埋 {{dig}} · 回收 {{target}} · 收束 {{convergence}}',
    fields: {
      name: '名称',
      name_en: '英文名',
      lineType: '线类型',
      priority: '优先级',
      status: '状态',
      arcSummary: '弧线摘要',
      storyline: '规划线',
      title: '标题',
      description: '说明',
      digChapter: '埋点章节',
      targetChapter: '目标回收章节',
      convergenceChapter: '收束章节',
      importance: '重要度',
      remindBefore: '提前提醒',
      includeInContext: '纳入上下文',
    },
    lineTypes: {
      main: '主线',
      romance: '感情线',
      power: '成长线',
      mystery: '悬疑线',
      politics: '权谋线',
    },
    status: {
      active: '活跃',
      dormant: '休眠',
      closed: '关闭',
    },
    subplotStatus: {
      dug: '已埋',
      filling: '填坑中',
      detonated: '已引爆',
    },
    messages: {
      storylineCreated: '规划线已创建',
      storylineUpdated: '规划线已保存',
      storylineDeleted: '规划线已删除',
      subplotCreated: '支线已创建',
      subplotUpdated: '支线已保存',
      subplotDeleted: '支线已删除',
      subplotFilling: '支线已进入填坑',
      subplotDetonated: '支线已引爆',
      weightsSaved: '权重已保存',
      saveFailed: '保存失败，请稍后重试',
      deleteFailed: '删除失败，请稍后重试',
      transitionFailed: '状态迁移失败',
      weightsFailed: '权重保存失败',
    },
  },
  storyState: {
    title: '故事状态',
    subtitle: '只读查看未回收伏笔、未引爆支线、收束密度和卷级字数预算。',
    chapter: '章节',
    loadFailed: '故事状态加载失败',
    debtTotal: '未清债务',
    convergenceDensity: '收束密度',
    currentPosition: '当前位置',
    positionValue: '第 {{chapter}} 章 · 第 {{volume}} 卷',
    wordBudgetValue: '{{current}} / {{total}} 章 · {{words}} 字',
    contextDigest: '上下文摘要',
    overdueForeshadows: '未回收伏笔',
    overdueSubplots: '未引爆支线',
    noForeshadows: '没有逾期伏笔。',
    noSubplots: '没有逾期支线。',
    trendTitle: '趋势',
    trendFrom: '起始章节',
    trendTo: '结束章节',
    trendInvalidRange: '请输入有效章节范围，跨度最多 1000 章。',
    trendLoadFailed: '趋势加载失败',
    recallRate: '回收率',
    subplotDensity: '支线密度',
    resolved: '已回收',
    overdue: '逾期',
  },
  character: {
    title: '角色',
    new: '新建角色',
    createTitle: '新建角色',
    editTitle: '编辑角色',
    dialogDescription: '维护角色设定字段；引擎追踪字段由章节流程自动更新。',
    empty: '暂无角色。新建角色后会显示在这里。',
    loadFailed: '角色加载失败',
    created: '角色已创建',
    updated: '角色已保存',
    deleted: '角色已删除',
    saveFailed: '角色保存失败，请稍后重试',
    deleteFailed: '角色删除失败，请稍后重试',
    deleteConfirm: '确认删除角色“{{name}}”？',
    delete: '删除角色',
    saving: '保存中',
    protagonist: '主角',
    roleUnset: '未设置角色定位',
    tagPlaceholder: '回车添加',
    removeTag: '移除 {{value}}',
    groups: {
      basic: '基础',
      profile: '设定',
      organization: '组织',
      other: '其它',
    },
    fields: {
      name: '名称',
      aliases: '别名',
      role: '角色定位',
      age: '年龄',
      gender: '性别',
      is_organization: '组织 / 团体',
      role_type: '角色类型',
      personality: '性格',
      background: '背景',
      appearance: '外貌',
      relationships: '关系',
      inner_flaw: '内在缺陷',
      identity_situation: '身份 / 处境',
      realm: '境界',
      realm_level: '境界等级',
      motivation: '动机',
      voice_signature: '语言特征',
      traits: '标签特质',
      organization_type: '组织类型',
      organization_purpose: '组织目标',
      organization_members: '组织成员',
      notes: '备注',
      avatar_url: '头像 URL',
      status: '状态',
    },
  },
  characterState: {
    title: '角色状态',
    subtitle: '展示所选分支的当前快照与历史时间线；状态由章节生成后自动抽取更新。',
    branchPlaceholder: '选择分支',
    tabs: {
      current: '当前态',
      history: '历史时间线',
    },
    empty: '暂无角色状态（生成章节后由 AI 自动抽取）',
    historyEmpty: '暂无角色状态历史（生成多章后会形成时间线）',
    loadFailed: '角色状态加载失败',
    historyLoadFailed: '角色状态历史加载失败',
    noFields: '暂无可展示状态字段',
    timelineTitle: '角色状态历史时间线',
    updatedThrough: '截至第 {{chapter}} 章',
    chapterBadge: '第 {{chapter}} 章',
    openChapter: '跳转第 {{chapter}} 章',
    evidenceEvent: '证据事件 #{{id}}',
    fields: {
      level: '等级',
      location: '位置',
      physical_state: '身体',
      emotional_state: '情绪',
      equipment: '装备',
      recent_events: '近况',
      current_goal: '目标',
      pending_foreshadow: '待回收伏笔',
      evidence_event: '证据事件',
    },
  },
  ingestReview: {
    evidenceMatch: { exact: '精确匹配', approximate: '近似匹配' },
    identity: {
      independent: '确认为独立实体', merge: '合并到既有实体', target: '目标实体 ID',
      mode: '实体审核模式', review_new: '审核新实体', review_all: '审核全部实体变更', auto_accept: '自动接受新实体',
      pending: '{{count}} 个待审实体 · 前往实体审核', pendingLink: '待审实体 · 前往实体审核',
      new_entity: '新实体', entity_type_conflict: '实体类型冲突', unknown_owner: '保管方身份待确认',
      character: '角色', location: '地点', faction: '组织', item: '物品', power: '能力',
    },
    filters: {
      status: '状态',
      chapter: '章节',
      chapterPlaceholder: '全部',
    },
    columns: {
      chapter: '章节',
      name: '角色名',
      aliases: '别名',
      attributes: '关键属性',
      evidence: '证据',
      status: '状态',
      actions: '操作',
    },
    status: {
      all: '全部',
      pending: '待审核',
      edited: '已编辑',
      accepted: '已接受',
      rejected: '已拒绝',
    },
    fields: {
      level: '等级',
      equipment: '装备',
      location: '位置',
      emotional_state: '情绪',
      active_conflicts: '冲突',
      relationships: '关系',
    },
    accept: '接受',
    reject: '拒绝',
    batchAccept: '批量接受',
    batchReject: '批量拒绝',
    prev: '上一页',
    next: '下一页',
    empty: '暂无审核项',
    loadFailed: '实体审核列表加载失败',
    actionFailed: '审核操作失败，请稍后重试',
    batchFailed: '批量操作失败，请稍后重试',
    saveFailed: '编辑保存失败，请稍后重试',
    selectPage: '选择当前页',
    selectRow: '选择 {{name}}',
    editTitle: '编辑 {{name}}',
  },
  skeleton: {
    title: '骨架规划',
    replanTitle: '重新规划骨架',
    subtitle: '输入目标字数后生成卷章骨架草稿，确认前不会写入项目。',
    confirmedTitle: '已确认骨架',
    confirmedHint: '当前项目已有落库的卷骨架；重新规划会先生成新草稿，确认后替换保存。',
    replan: '重新规划',
    targetWords: '目标字数',
    targetWordsPlaceholder: '默认读取项目目标字数',
    chapterWordTarget: '单章目标字数',
    chapterWordTargetPlaceholder: '按题材建议 {{value}} 字',
    propose: '生成骨架',
    proposing: '生成中',
    proposingHint: '模型正在规划卷骨架，通常需要 1-3 分钟（长篇更久），请耐心等待、勿关闭页面。',
    proposeDone: '骨架草稿已生成',
    proposeFailed: '骨架生成失败，请稍后重试',
    confirm: '确认骨架',
    confirming: '确认中',
    confirmDone: '骨架已确认',
    confirmFailed: '骨架确认失败，请稍后重试',
    confirmHint: '确认后将以 {{value}} 字/章写入卷骨架。',
    loadFailed: '骨架加载失败',
    noChaptersHint: '项目暂无章节，建议先完成骨架规划，再进入章节生成。',
    summary: {
      totalChapters: '总章数',
      volumeCount: '卷数',
      totalWords: '规划字数',
    },
    volumeTitle: '第 {{value}} 卷',
    chapterSingle: '第 {{value}} 章',
    chapterRange: '第 {{start}}-{{end}} 章',
    wordBudget: '{{value}} 字',
    outline: '卷大纲',
    outlinePlaceholder: '描述本卷主线、冲突推进和结尾钩子。',
    emptyOutline: '暂无卷大纲',
    milestones: '里程碑',
    addMilestone: '添加里程碑',
    addForeshadowPlant: '添加埋设',
    addForeshadowPayoff: '添加回收',
    removeForeshadow: '移除伏笔',
    foreshadowKeyPlaceholder: '伏笔名称，如「断骨伞」',
    foreshadowDetailPlaceholder: '说明这条伏笔埋下/回收的内容',
    removeMilestone: '移除里程碑',
    milestonePlaceholder: '关键事件或转折',
    emptyMilestones: '暂无里程碑',
    foreshadowPlant: '伏笔埋设',
    foreshadowPayoff: '伏笔兑现',
    emptyForeshadow: '暂无伏笔',
    prevPage: '上一页',
    nextPage: '下一页',
    pageIndicator: '第 {{page}} / {{total}} 页',
    edit: '编辑骨架',
    editTitle: '编辑已确认骨架',
    editHint: '直接修改卷大纲和里程碑，保存后即时覆盖已落库的骨架，不会重新调用模型。',
    save: '保存修改',
    saving: '保存中',
    updateDone: '骨架已更新',
    updateFailed: '骨架更新失败，请稍后重试',
  },
  chapter: {
    number: '章序',
    numberShort: '第{{value}}章',
    chapterNumber: '第 {{value}} 章',
    title: '章节标题',
    words: '字数',
    wordsValue: '{{value}} 字',
    status: '状态',
    branch: '分支',
    untitled: '未命名章节',
    loadFailed: '章节加载失败',
    selectEmptyTitle: '选择一个章节',
    selectEmptyBody: '从左侧章节树选择章节后，这里会显示标题、状态、字数和正文预览。',
    contentEmpty: '此章节暂无正文内容。',
    s2cHint: '当前为基础预览；阅读器支持字体、行宽和全屏阅读设置。',
    review: {
      title: '一致性冲突待处理',
      description: '本章存在未解决的一致性冲突, 已拦截完成态。请前往一致性页解决冲突后重新提交。',
      conflictSummary: '未解决冲突 {{count}} 条：{{detail}}',
      conflictListTitle: '未解决冲突 {{count}} 条：',
      moreConflicts: '等 {{count}} 条',
      severity: {
        hard: '硬冲突',
        soft: '软冲突',
      },
      viewConflicts: '查看冲突',
      resubmit: '重新提交审核',
      resubmitted: '章节已重新提交审核',
      badgeTitle: '存在一致性冲突待解决',
    },
    partialResult: {
      title: '本章仅生成了部分内容',
      description: '下游工位已按阻断处理；你可以重新生成本章，或暂时保留当前部分结果。',
      regenerate: '重新生成本章',
      keep: '保留',
      badgeTitle: '本章仅生成部分内容，下游已按阻断处理；可重新生成或保留',
    },
    refine: {
      action: '旗舰精修',
      generated: '旗舰精修已生成',
      fallbackKept: '精修失败，已保留初稿',
    },
    version: {
      currentVersion: '当前版本',
      selectedVersion: '所选版本',
      diffDirection: '对比方向：当前版本 ← → 所选版本',
      back: '返回',
      keepDraft: '保留初稿',
      adopt: '采纳',
      restore: '恢复此版本',
      sourceStale: '正文已更新，需重新生成',
      keepDraftSuccess: '已保留初稿',
      adoptSuccess: '已采纳旗舰精修',
      restoreSuccess: '已恢复该版本（原当前版已存入历史）',
    },
    generate: {
      modeLabel: '生成模式',
      easyMode: '简易',
      advancedMode: '高级',
      easyHint: '点一下, AI 自动拟好本章大纲并开始写。写完停在本工位, 是否进入下一工位由你决定。',
      easyStart: '写下一章',
      easyDrafting: '正在拟大纲',
      easyDetails: '查看/修改本章参数',
      easyDraftFailed: '拟大纲失败, 可切到高级模式手动填写',
      easyProjectUnavailable: '项目信息还没加载好, 稍后再试',
      stationTitle: '章节生成 · 阶段 0 工位',
      stageBadge: '章节正文 · 阶段 0',
      formHint: '简易模式一键成章; 高级模式可逐项填写大纲和参数。',
      newChapter: '新建章节',
      generatingDisabled: '章节生成中，暂不能新建',
      chapterNumber: '章序',
      title: '章节标题',
      titlePlaceholder: '可留空，完成后以后端返回标题为准',
      outline: '章节大纲',
      outlinePlaceholder: '写下这一章的主要事件、情绪转折和关键场景。',
      outlineRequired: '请输入章节大纲',
      outlineHint: '完成前不会写入卷章树；完成后会刷新并选中新章节。',
      outlineLoadFailed: '章节大纲加载失败',
      outlineSaveFailed: '章节大纲保存失败',
      outlineConfirmFailed: '章节大纲确认失败',
      outlineSaved: '章节大纲已保存',
      outlineConfirmed: '章节大纲已确认',
      outlineStatusDraft: '待确认',
      outlineStatusConfirmed: '已确认',
      outlineConfirmHint: '确认章节大纲后才能生成正文。',
      outlineReadyHint: '章节大纲已确认，可以生成正文。',
      sceneBeats: '场景节拍',
      keyEvents: '关键事件',
      characters: '出场角色',
      confirmOutline: '确认大纲',
      targetWords: '目标字数',
      mode: '章节模式',
      lang: '生成语言',
      creditEstimate: '生成费用预估',
      creditEstimateValue: '预计 {{estimated}} / 可用 {{available}}',
      creditEstimateUnavailable: '确认大纲后显示',
      estimatingCredits: '正在预估…',
      estimateFailed: '费用预估失败',
      insufficientCredits: '余额不足，已拦截生成请求',
      submit: '生成',
      abort: '取消',
      abortConfirm: '正在生成，中断将丢失已生成内容，确认？',
      switchAwayConfirm: '正在生成，切换章节将中断当前生成，确认？',
      generatingChapter: '正在生成 第 {{value}} 章…',
      failedTitle: '第 {{value}} 章生成失败',
      waitingForStream: '等待模型返回内容…',
      nonIdempotentHint: '生成失败可安全重试，系统会复用幂等锁避免重复扣费。',
      idempotentRetryHint: '断线会自动恢复，手动重试会复用同一章节幂等锁。',
      reconnecting: '连接中断，正在第 {{value}} 次自动恢复…',
      reconnectFailed: '生成流恢复失败，请重试。',
      retry: '重试',
      errorMeta: '错误类型：{{category}} · {{code}}',
      invalidDonePayload: '生成完成事件格式异常',
      doneRefreshFailed: '章节已生成，若列表未更新请刷新',
      defaultsFailed: '读取生成默认值失败，请重新打开表单。',
      downstreamManual: '已完成，可在成品流水线手动生成剧本',
      downstreamPulse: '下游工位（剧本）将开始脉动',
      doneSummary: '《{{title}}》已完成，{{words}} 字，{{provider}}，耗时 {{duration}}',
      langs: {
        zh: '中文',
        en: '英文',
      },
    },
    statusValue: {
      unknown: '未知',
      pending: '等待中',
      done: '完成',
      failed: '失败',
      needs_review: '待复核',
      partial_result: '部分结果',
      passed: '通过',
    },
  },
  board: {
    title: '脉动看板',
    subtitle: '按 6 个 PAL 工位查看章节文字任务与媒体资产',
    view: {
      label: '看板视图',
      single: '单作品',
      overview: '工厂总览',
    },
    selectProject: '选择项目',
    emptyProjects: '暂无项目可查看',
    emptyJobs: '当前项目暂无生成任务',
    emptyChapterTexts: '暂无已生成正文',
    emptyAssets: '此工位暂无资产',
    emptyDrawerAssets: '此章节暂无可展开资产',
    chapter: '第{{number}}章',
    chapterTitle: '第 {{number}} 章 · {{title}}',
    chapterId: '章节 {{id}}',
    chapterUnknown: '章节未绑定',
    segments: '{{current}}/{{total}} 段',
    runningSegments: '{{current}}/{{total}} 段',
    runningCount: '进行中 {{count}}',
    stageSource: '源头',
    stageSourceHint: '手稿 · 章节正文',
    stageAdapt: '改编',
    stageAdaptHint: '剧本 · 分镜',
    stageProduce: '成片',
    stageProduceHint: '出图 · 声音 · 视频',
    sectionGenerating: '生成中',
    sectionGenerated: '已生成章节',
    sectionInFlight: '进行中的章节',
    attempts: '尝试',
    chapterMode: '章节模式',
    wordCount: '字数',
    noWordCount: '无',
    quality: '质量分',
    noQuality: '无',
    qualityStatus: '状态 {{status}}',
    qualityLayer: '层级 {{layer}}',
    qualityDegradedRatio: '退化 {{degraded}}/{{total}}',
    qualityDegraded: '退化 {{count}}',
    qualityRecorded: '已记录质量信息',
    stageVersion: '阶段 / 版本',
    stageVersionValue: '阶段 {{stage}} · 版本 {{version}}',
    stageValue: '阶段 {{stage}}',
    versionValue: '版本 {{version}}',
    jobDrawerTitle: '第{{chapter}}章资产',
    assetDrawerTitle: '{{type}}详情',
    jobId: '任务ID',
    resultChapter: '结果章节',
    assetId: '资产ID',
    chapterAsset: '章节',
    chapterAssetId: '章节ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    assetPreview: '资产预览',
    assetDownload: '下载',
    noPreviewAsset: '无可预览资产',
    previewLoadFailed: '预览加载失败',
    mediaUnsupported: '当前浏览器不支持此媒体预览',
    chapterImageAlt: '章节图片',
    payloadJson: '开发者详情',
    developerDetails: '开发者详情',
  },
  overview: {
    title: '工厂总览',
    matrixTitle: '工厂总览',
    project: '作品',
    generating: '生成中',
    awaitingConfirm: '待确认',
    running: '运行中',
    empty: '暂无在产作品',
    loadFailed: '工厂总览加载失败',
    projectTotals: '待确认 {{awaiting}} · 生成中 {{generating}}',
    intervention: {
      message: '⚠️ {{projectCount}} 个作品共 {{chapterCount}} 章待确认待处理',
      action: '去处理',
    },
  },
  library: {
    title: '作品库',
    subtitle: '按作品查看每章跨工位成品，支持状态筛选与分页。',
    selectProject: '选择项目',
    statusFilter: '筛选状态',
    total: '共 {{total}} 章',
    empty: '暂无章节',
    untitled: '未命名',
    noWords: '无',
    chapterTitle: '第 {{number}} 章 · {{title}}',
    columns: {
      chapter: '章节',
      project: '作品',
      status: '状态',
      words: '字数',
      updated: '更新时间',
    },
    modalitiesLabel: '成品状态',
    modalityReady: '{{modality}}已就绪',
    modalityMissing: '{{modality}}未就绪',
    modalities: {
      screenplay: '剧本',
      storyboard: '分镜',
      panel_image: '出图',
      audio: '声音',
      video: '视频',
    },
    status: {
      all: '全部',
      done: '已完成',
      stopped: '已停止',
      awaiting_confirm: '待确认',
    },
    statusValue: {
      unknown: '未知',
      done: '已完成',
      completed: '已完成',
      complete: '已完成',
      finished: '已完成',
      stopped: '已停止',
      awaiting_confirm: '待确认',
      running: '进行中',
      generating: '生成中',
      streaming: '生成中',
      writing: '写作中',
      drafting: '起草中',
      needs_review: '待复核',
      partial_result: '部分结果',
      failed: '失败',
    },
  },
  cascade: {
    reason: { already_running: '该工位已在运行中', policy_blocked: '当前策略不允许继续，请检查流水线设置', not_enqueued: '未启动新任务', other: '未启动新任务：{{reason}}' },
    state: {
      running: '自动进行中',
      awaiting_confirm: '暂停待确认',
      stopped: '已停止',
    },
    actions: {
      continue: '继续',
      stop: '停止',
    },
    toast: {
      continued: '已继续级联',
      stopped: '已停止级联',
    },
  },
  station: {
    text: '文字',
    screenplay: '剧本',
    storyboard: '分镜',
    image: '出图',
    audio: '声音',
    video: '视频',
  },
  assetStatus: {
    pending: '等待中',
    passed: '通过',
    needs_review: '待复核',
    failed: '失败',
    isolated: '隔离',
  },
  assetType: {
    chapter_text: '文字',
    screenplay: '剧本',
    storyboard: '分镜',
    panel_image: '出图',
    character_design: '角色设计',
    audio: '声',
    video: '视',
    config: '配置',
  },
  payload: {
    quality: '质量分',
    score: '评分',
    title: '标题',
    summary: '摘要',
    url: 'URL',
    image_url: '图片 URL',
    audio_url: '音频 URL',
    video_url: '视频 URL',
    duration: '时长',
    duration_ms: '时长(ms)',
    word_count: '字数',
    panel_count: '画格数',
    scene_count: '场景数',
  },
  job: {
    status: {
      pending: '等待中',
      structure_planning: '结构规划',
      paragraph_generating: '段落生成',
      qc_check: '质检中',
      copy_editing: '文案编辑',
      scene_editing: '场景编辑',
      retry_scheduled: '等待重试',
      done: '完成',
      failed: '失败',
      needs_review: '待复核',
      partial_result: '部分结果',
    },
  },
  submitJob: {
    open: '提交章节生成',
    title: '提交章节生成',
    description: '提交一章或一组章节进入生成队列。',
    mode: '提交模式',
    singleMode: '单章',
    batchMode: '批量',
    chapterNo: '章序',
    chapterNoRequired: '请输入章序',
    startChapterNo: '起始章序',
    startChapterNoRequired: '请输入起始章序',
    chapterCount: '章节数',
    chapterCountRequired: '请输入章节数',
    chapterCountHint: '一次可提交 1-{{max}} 章',
    outline: '章节大纲',
    sharedOutline: '共享章节大纲',
    outlineRequired: '请输入章节大纲',
    targetWords: '目标字数',
    targetWordsRequired: '请输入目标字数',
    wordsHint: '目标字数必须在 {{min}}-{{max}} 之间，默认 {{defaultValue}}',
    chapterMode: '章节模式',
    chapterModeRequired: '请选择章节模式',
    volumeNo: '卷序',
    volumeNoHint: '可选，默认第 1 卷',
    lang: '生成语言',
    submit: '提交',
    submitted: '章节生成任务已提交',
    batchSubmitted: '已提交 {{count}} 个章节生成任务',
  },
  jobChapterMode: {
    regular: '常规',
    climax: '高潮',
    thematic: '主题章',
    volume_opening: '卷首章',
    volume_finale: '卷终章',
  },
  generate: {
    title: '即时生成章节',
    writeNext: '写下一章',
    drafting: '正在构思下一章',
    customize: '展开并调整章节细节',
    hideDetails: '收起章节细节',
    draftFailed: '下一章草案生成失败，请手动补充后重试',
    chapterNumber: '章序',
    chapterNumberRequired: '请输入章序',
    chapterTitle: '章节标题',
    outline: '章节大纲',
    outlineRequired: '请输入章节大纲',
    targetWords: '目标字数',
    chapterMode: '章节模式',
    start: '开始生成',
    generating: '生成中',
    preview: '流式预览',
    completed: '章节已生成',
    readNow: '立即阅读',
    invalidDonePayload: '生成完成事件格式异常',
    doneSummary: '《{{title}}》已完成，{{words}} 字，{{provider}}，耗时 {{duration}}',
    wordCountEstimate: '预估区间 {{range}} 字（目标 {{target}}）',
    wordCountActualRange: '实际 {{actual}} 字；目标区间 {{min}}-{{max}} 字',
    wordCountUnderWarning: '实际字数低于预估区间，较目标少 {{delta}} 字。',
    wordCountOverWarning: '实际字数高于预估区间，较目标多 {{delta}} 字。',
  },
  reader: {
    title: '阅读器',
    openReader: '阅读',
    close: '关闭',
    toc: '目录',
    tocDescription: '《{{title}}》章节目录',
    tocLoading: '章节目录加载中',
    emptyToc: '暂无章节可阅读。',
    chapterProgress: '章节进度',
    readingProgress: '阅读进度',
    pickChapterTitle: '从目录选择章节',
    pickChapterDescription: '目录已打开，你可以跳转到任意章节开始审阅成品正文。',
    loadFailed: '阅读器加载失败',
    backToProject: '返回项目',
    backToToc: '回目录',
    branch: '分支',
    theme: '阅读主题',
    paperTheme: '纸张',
    nightTheme: '夜间',
    export: '导出',
    exporting: '导出中',
    exportFormat: '导出格式',
    exportDone: '导出已开始下载',
    exportFailed: '导出失败',
    exportFormats: {
      epub3: 'EPUB 3',
      txt: 'TXT',
      md: 'Markdown',
      fdx: 'FDX',
      fountain: 'Fountain',
      pdf: 'PDF',
      'bilingual-md': '中英对照 Markdown',
      'bilingual-docx': '中英对照 DOCX',
    },
    exportCenter: {
      title: '导出中心',
      description: '集中导出整部项目，覆盖阅读、出版和专业剧本交付格式。',
      primary: '主入口',
      comingSoon: '后续支持',
      exportAction: '导出',
      goldenContract: 'Golden 契约：合规 Final Draft FDX，可用于专业剧本交付。',
      formats: {
        fdx: {
          title: 'FDX',
          description: '面向 Final Draft 和制片流程的专业剧本包。',
        },
        'bilingual-md': {
          title: '中英对照 MD',
          description: '调用剧本翻译模型，导出逐行中英对照的《名门》格式 Markdown。',
        },
        'bilingual-docx': {
          title: '中英对照 DOCX',
          description: '调用剧本翻译模型，导出带命名样式和旁白斜体的 Word 文档。',
        },
        epub3: {
          title: 'EPUB 3',
          description: '适合阅读器和分发检查的可重排电子书包。',
        },
        md: {
          title: 'Markdown',
          description: '适合编辑、版本管理和后续转换的可移植稿源。',
        },
        txt: {
          title: 'TXT',
          description: '适合轻量审阅和归档流水线的纯文本导出。',
        },
        fountain: {
          title: 'Fountain',
          description: '纯文本剧本格式(人可读/独立编剧圈流行)。',
        },
        pdf: {
          title: 'PDF',
          description: '固定版式校样占位，后续接入可打印导出器。',
        },
      },
    },
    tab: {
      label: '阅读内容',
      text: '文字',
      comic: '漫画',
      video: '视频',
    },
    emptyScript: '本章暂无剧本',
    emptyStoryboard: '本章暂无分镜',
    script: {
      sceneFallback: '场景 {{index}}',
      unknownSpeaker: '角色',
      jumpToStoryboard: '查看分镜',
      jumpToStoryboardScene: '查看 {{scene}} 的分镜',
    },
    storyboard: {
      panelNo: '镜头 {{number}}',
      imagePending: '出图待生成',
      imageAlt: '镜头出图',
      jumpToScene: '跳到剧本场景 {{scene}}',
      transition: '转场',
    },
    consume: {
      comicEmpty: '本章暂无漫画分镜，请先在工作台生成分镜。',
      comicPanelAlt: '漫画第 {{number}} 格',
      videoEmpty: '本章视频尚未生成，请先在工作台生成视频。',
      videoGenerate: '生成视频',
      videoUnsupported: '当前浏览器不支持视频播放。',
    },
    modalities: {
      text: '正文',
      image: '图像',
      audio: '音频',
      video: '视频',
    },
    chapterNumber: '第 {{number}} 章',
    untitled: '未命名章节',
    headerImageAlt: '章首图',
    audioUnsupported: '当前浏览器不支持音频播放。',
    settings: '阅读设置',
    chapterHeading: '第{{number}}章：{{title}}',
    fontSize: '字体大小：{{size}}px',
    fontSizeLabel: '字体大小',
    lineHeight: '行高：{{value}}',
    fontFamily: '阅读字体',
    fontKai: '楷体',
    fontSong: '宋体',
    previous: '上一章',
    next: '下一章',
    wordCount: '{{value}} 字',
    firstChapter: '已是第一章',
    lastChapter: '已是最后一章',
  },
  pagination: {
    range: '显示 {{start}}-{{end}} / 共 {{total}}',
    single: '显示第 {{index}} / 共 {{total}}',
    page: '{{page}} / {{total}}',
    pageWithUnit: '{{page}} / {{total}} 页',
    totalAssets: '共 {{total}} 个资产',
    totalImages: '共 {{total}} 张',
    pageSize: '每页',
    first: '首页',
    previous: '上一页',
    next: '下一页',
    last: '末页',
  },
  consistencyDashboard: {
    recordedAt: '冲突记录时间：{{time}}',
    referenceInvalid: '引用已失效',
    cleanupReference: '清理失效引用',
    cleanupConfirm: '确认关闭这条失效引用冲突？记录会保留在历史中。',
    recheckRegistration: '重新评估登记',
    recheckConfirm: '按当前地点登记重新评估？符合原校验规则时将关闭这条冲突，并保留历史记录。',
    reviewResolved: '冲突已关闭，历史记录已保留',
    reviewFailed: '暂时无法关闭冲突，请核对地点登记与引入章节',
    title: '一致性看板',
    subtitle: '当前项目：{{project}}',
    noProject: '请先创建项目',
    loadFailed: '一致性冲突加载失败',
    chapterNo: '第 {{chapter}} 章',
    projectPicker: {
      label: '项目',
      placeholder: '选择项目',
      noProjects: '请先创建项目',
    },
    stats: {
      hard: '硬冲突 {{count}}',
      soft: '软冲突 {{count}}',
      overridden: '已标记例外 {{count}}',
    },
    filters: {
      severity: '严重度',
      all: '全部',
      chapter: '章节号',
      chapterPlaceholder: '全部章节',
      clearChapter: '清除章节',
    },
    severity: {
      hard: '硬',
      soft: '软',
    },
    softStatus: {
      title: '章节一致性状态',
      running: '软一致性检测中…',
      done_flagged: '发现 {{count}} 处提示',
      done_clean: '✓ 无软一致性问题',
      failed: '检测未完成，可重试',
      none: '未检测',
      disabled: '未开启',
    },
    softRules: {
      ooc: '人设偏离',
      setting: '设定软矛盾',
      emotion: '情绪逻辑断裂',
    },
    experimentalBadge: '实验性·建议复核',
    fields: {
      rule: '规则：',
      entity: '实体：',
    },
    actions: {
      viewContext: '查看上下文',
      override: '标记例外',
      markLongTerm: '标为长线',
      openChapter: '打开章节',
      openChapterTitle: '打开该冲突所在章节',
      resubmit: '重新提交',
      partialRewrite: 'AI 局部重写',
    },
    longTerm: {
      title: '标记为长线伏笔',
      hint: '长线伏笔可以跨卷，但不能没有期限。填一个回收章节，到期未回收会重新亮起；全书结束时所有未结清的伏笔都会被列出，长线也不例外。',
      chapterLabel: '承诺在第几章回收',
      chapterPlaceholder: '例如 10',
      chapterHint: '必须晚于本章。到了这一章仍未回收，这条会重新拦截。',
      submit: '标为长线',
      saved: '已标为长线伏笔',
    },
    override: {
      title: '标记合法例外',
      warning: '标记例外不是关掉它，而是把它记成一笔有期限的账：填写原因和承诺解释的章节，过期未解释会自动重新亮起。',
      dueChapterLabel: '承诺在第几章之前给出交代',
      dueChapterPlaceholder: '例如 9',
      dueChapterHint: '到了这一章仍未解释，这条冲突会自动重新亮起。全书结束时所有未结清的伏笔都会被列出。',
      placeholder: '输入例外原因',
      submit: '提交',
      overridden: '已标记例外',
      noReason: '未记录原因',
      reasons: {
        intentionalLongArc: '故意长线伏笔',
      },
    },
    empty: {
      title: '正典一致',
      description: '当前项目没有一致性冲突。',
      filteredTitle: '当前过滤条件下无冲突',
      filteredDescription: '可调整严重度或章节过滤查看其它冲突。',
    },
    messages: {
      overrideSaved: '例外标记已保存',
      resubmitted: '章节已重新提交',
      chapterMissing: '未找到对应章节',
      rewriteNoContent: '该章节没有可重写内容',
    },
  },
  conflictContext: {
    title: '冲突上下文',
    detailLabel: '冲突说明',
    earliestTrigger: '最早触发章 · 第 {{chapter}} 章{{title}}',
    latestTrigger: '最晚触发章 · 第 {{chapter}} 章{{title}}',
    sameContentHint: '两端正文一致，真正的设定背离可能在中间章节，详见上方冲突说明。',
    entityNotLocated: '未在正文定位到「{{entity}}」，可能存在别名 / 缩写 / 错别字。',
    entityApproximate: '正文里没有「{{entity}}」这个说法，最接近的是「{{matched}}」（已高亮）。若正文写的是普通叙述而非专有名称，多半是抽取时把它误当成了实体。',
    chapterMissing: '未找到对应章节。',
    noContent: '该章节暂无正文。',
  },
  relationGraph: {
    loadFailed: '关系图加载失败',
    empty: '暂无关系数据。生成章节或导入记忆后，人物、物品、地点和阵营关系会显示在这里。',
    causalityEmpty: '暂无因果链数据。完成章节记忆抽取后，强因果事件会显示在这里。',
    views: {
      relations: '关系视图',
      causality: '因果视图',
    },
    snapshot: {
      label: '章节快照',
      all: '全部关系',
      chapter: '第 {{chapter}} 章',
    },
    export: {
      title: '实体关系图',
      causalityTitle: '事件因果图',
      svg: '导出 SVG',
    },
    legend: {
      nodes: '节点',
      edges: '关系',
    },
    detail: {
      title: '节点详情',
      relatedEdges: '相关边',
      noRelatedEdges: '暂无相关边',
      jumpCharacterState: '跳人物状态',
      jumpChapter: '跳章节',
      eventType: '事件类型',
      chapter: '章节',
      characterReadOnlyFallback: '未能读取人物详情，已降级为只读基本信息。',
      save: '保存正典',
      saveSuccess: '正典已保存',
      saveFailed: '正典保存失败',
      fields: {
        name: '名称',
        aliases: '别名',
        role: '角色',
        personality: '性格',
        motivation: '动机',
        realm: '境界',
        realmLevel: '境界层级',
        background: '背景',
        appearance: '外貌',
        status: '状态',
        type: '类型',
      },
    },
    foreshadow: {
      title: '伏笔追踪',
      summary: '未回收 {{unresolved}} / 全部 {{total}}',
      empty: '暂无伏笔边。',
      loadFailed: '伏笔加载失败',
      setChapter: '埋设章：{{chapter}}',
      unresolved: '未回收',
      resolvedAt: '已回收 @ 第 {{chapter}} 章',
      jump: '跳转章节',
      resolve: '回收',
      resolveTitle: '回收伏笔',
      resolveChapter: '回收章节',
      resolveSuccess: '伏笔已回收',
      resolveFailed: '伏笔回收失败',
    },
    nodeTypes: {
      character: '人物',
      faction: '阵营',
      item: '物品',
      location: '地点',
      power: '能力',
      event: '事件',
      foreshadow: '伏笔',
      chapter: '章节',
      unknown: '未知',
    },
    eventTypes: {
      character_introduce: '人物登场',
      character_evolve: '人物变化',
      location_introduce: '地点出现',
      location_update: '地点更新',
      plot_advance: '剧情推进',
      plot_resolve: '剧情解决',
      timeline_event: '时间线事件',
      chapter_control_card: '章节控制卡',
      power_introduce: '能力出现',
      power_cultivate: '能力修炼',
      power_breakthrough: '能力突破',
      faction_introduce: '阵营出现',
      faction_relation: '阵营关系',
      entity_edge: '实体关系',
      item_introduce: '物品出现',
      item_transfer: '物品转移',
      item_destroy: '物品毁坏',
    },
    edgeTypes: {
      master_of: '师承',
      disciple_of: '门徒',
      rival_of: '宿敌',
      ally_of: '盟友',
      family_of: '亲缘',
      lover_of: '爱慕',
      located_at: '位于',
      member_of: '隶属',
      owns: '拥有',
      wields: '持有',
      cultivates: '修炼',
      contains: '包含',
      adjacent_to: '毗邻',
      ally_with: '结盟',
      war_with: '交战',
      vassal_of: '附庸',
      foreshadows: '伏笔',
      combat_with: '交战',
      allied: '盟友',
      ally: '盟友',
      hostile: '敌对',
      enemy: '敌对',
      holds: '持有',
      mentor: '师承',
      loves: '情感',
      causes: '因果',
      default: '其它',
    },
  },
  partialRegenerate: {
    title: 'AI 局部重写',
    toolbarAction: 'AI重写',
    toolbarTooltip: '重写选中内容',
    selectedCount: '已选 {{value}} 字',
    original: '原文',
    rewritten: '重写结果',
    instruction: '重写指令',
    instructionPlaceholder: '描述希望如何重写，例如加强心理描写、改成更紧凑的节奏、按角色口吻改写等',
    lengthMode: '长度模式',
    targetChars: '目标字数',
    targetCharsRequired: '请输入目标字数',
    generate: '生成',
    regenerate: '重新生成',
    apply: '应用',
    discard: '放弃',
    applied: '重写内容已应用',
    discarded: '已放弃本次重写',
    streamingPreview: '流式预览',
    diffPreview: '差异预览',
    waiting: '等待模型返回内容…',
    invalidDonePayload: '局部重写完成事件格式异常',
    freeformInstructionRequired: '自由模式需要填写重写指令',
    modes: {
      similar: '相近',
      expand: '扩写',
      condense: '精简',
      custom: '自定义',
      freeform: '按指令',
    },
  },
  markdown: {
    empty: '暂无内容',
    imageAlt: '章节图片',
  },
  status: {
    common: {
      unknown: '未知',
      custom: '{{status}}',
    },
    project: {
      planning: '规划中',
      writing: '创作中',
      in_progress: '进行中',
      paused: '暂停',
      completed: '已完成',
      archived: '已归档',
    },
    chapter: {
      done: '已完成',
      completed: '已完成',
      complete: '已完成',
      finished: '已完成',
      stopped: '已停止',
      awaiting_confirm: '待确认',
      needs_review: '待复核',
      partial_result: '部分完成',
      running: '进行中',
      generating: '生成中',
      streaming: '生成中',
      writing: '写作中',
      drafting: '起草中',
      failed: '失败',
    },
    job: {
      pending: '等待中',
      structure_planning: '结构规划中',
      paragraph_generating: '段落生成中',
      qc_check: '质检中',
      copy_editing: '润色中',
      scene_editing: '场景编辑中',
      retry_scheduled: '等待重试',
      done: '已完成',
      failed: '失败',
      needs_review: '待复核',
      partial_result: '部分结果',
    },
    asset: {
      pending: '等待中',
      passed: '通过',
      needs_review: '待复核',
      needs_review_attention: '⚠️ 待复审',
      failed: '失败',
      isolated: '隔离',
    },
    cascade: {
      running: '进行中',
      awaiting_confirm: '待确认',
      stopped: '已停止',
    },
    quality: {
      passed: '通过',
      done: '完成',
      failed: '失败',
      needs_review: '待复核',
      partial_result: '部分结果',
      unknown: '未知',
    },
  },
  projectStatus: {
    planning: '规划中',
    writing: '创作中',
    in_progress: '进行中',
    paused: '暂停',
    completed: '已完成',
    archived: '已归档',
  },
  state: {
    running: '运行中',
    done: '完成',
    failed: '失败',
    needs_review: '待复核',
    partial_result: '部分',
  },
}
